{
  "actual_edges": [
    {
      "from": "w1",
      "id": "w1-to-w2",
      "kind": "actual",
      "to": "w2"
    },
    {
      "from": "w2",
      "id": "w2-to-w3",
      "kind": "actual",
      "to": "w3"
    },
    {
      "from": "w3",
      "id": "w3-to-w4",
      "kind": "actual",
      "to": "w4"
    },
    {
      "from": "w4",
      "id": "w4-to-w5",
      "kind": "actual",
      "to": "w5"
    },
    {
      "from": "w5",
      "id": "w5-to-w6",
      "kind": "actual",
      "to": "w6"
    },
    {
      "from": "w6",
      "id": "w6-to-w7",
      "kind": "actual",
      "to": "w7"
    },
    {
      "from": "w7",
      "id": "w7-to-w8",
      "kind": "actual",
      "to": "w8"
    },
    {
      "from": "w8",
      "id": "w8-to-w9",
      "kind": "actual",
      "to": "w9"
    },
    {
      "from": "w9",
      "id": "w9-to-w10",
      "kind": "actual",
      "to": "w10"
    },
    {
      "from": "w10",
      "id": "w10-to-w11",
      "kind": "actual",
      "to": "w11"
    },
    {
      "from": "w11",
      "id": "w11-to-w12",
      "kind": "actual",
      "to": "w12"
    },
    {
      "from": "w12",
      "id": "w12-to-w13",
      "kind": "actual",
      "to": "w13"
    },
    {
      "from": "w13",
      "id": "w13-to-w14",
      "kind": "actual",
      "to": "w14"
    },
    {
      "from": "w14",
      "id": "w14-to-w15",
      "kind": "actual",
      "to": "w15"
    },
    {
      "from": "w15",
      "id": "w15-to-w16",
      "kind": "actual",
      "to": "w16"
    },
    {
      "from": "w16",
      "id": "w16-to-w17",
      "kind": "actual",
      "to": "w17"
    },
    {
      "from": "w17",
      "id": "w17-to-w18",
      "kind": "actual",
      "to": "w18"
    },
    {
      "from": "w18",
      "id": "w18-to-w19",
      "kind": "actual",
      "to": "w19"
    }
  ],
  "agent_commit": "c96f2ed3595162a174e680b563337f6215f6eace",
  "branch_semantics": {
    "available_actions": "legal-actions-not-future-state-branches",
    "event_choices": "legal-options-not-executed-unless-selected",
    "projected_counterfactual_states": false
  },
  "campaign_id": "playthrough-evidence-full-v1",
  "cell_id": "money-seed-42-0814df41bd32",
  "completed_weeks": 19,
  "difficulty": "normal",
  "final_ending": "cashflow_collapse",
  "game_commit": "348b9fd5501e71ebc7142e10f9068fc1490b5124",
  "game_tree": "225cd5451d09bb92da674234a79ecaf8db4beb3a",
  "nodes": [
    {
      "anomalies": [],
      "attractors": [],
      "available_action_ids": [
        "problem_set",
        "library_day",
        "language_school_germany",
        "language_tandem",
        "write_email_practice",
        "watch_german_news",
        "insurance_paperwork",
        "bank_account",
        "budget_call",
        "sell_unused_stuff",
        "rent_talk_extension",
        "cook_at_home",
        "student_club",
        "go_running",
        "bilibili_rest"
      ],
      "decision": {
        "confidence": 1.0,
        "expected_tradeoff": "deterministic fixture authoring choice",
        "risk_awareness": [
          "school_registration_deadline"
        ],
        "strategic_goal": "exercise money priorities"
      },
      "delta": {
        "academic_progress": 12,
        "energy": -52,
        "exam_readiness": 17,
        "hunger": 2,
        "language": 19,
        "money": -358,
        "social": 5,
        "stress": 12
      },
      "event": {
        "id": "arrival",
        "legal_choices": [
          {
            "choice_id": "arrival.choice_01_先去宿舍放行李",
            "failure_effects": {
              "energy": -4.0,
              "stress": 4.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "arrived",
            "success_effects": {
              "energy": 10.0,
              "stress": -4.0
            },
            "success_rate": 1.0,
            "text": "先去宿舍放行李"
          },
          {
            "choice_id": "arrival.choice_02_立刻去超市和_dm_补生活用品",
            "failure_effects": {
              "energy": -6.0,
              "hunger": 6.0,
              "money": -55.0,
              "stress": 4.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "arrived_supplied",
            "success_effects": {
              "energy": -6.0,
              "hunger": -10.0,
              "money": -55.0,
              "stress": -3.0
            },
            "success_rate": 1.0,
            "text": "立刻去超市和 dm 补生活用品"
          },
          {
            "choice_id": "arrival.choice_03_先激活_sim_卡和银行_app",
            "failure_effects": {
              "stress": 8.0,
              "visa_progress": -2.0
            },
            "next_event_id": "",
            "requirements": {
              "language": 0.003
            },
            "set_flag": "arrived",
            "success_effects": {
              "language": 1.0,
              "stress": 4.0,
              "visa_progress": 4.0
            },
            "success_rate": 0.746,
            "text": "先激活 SIM 卡和银行 App"
          },
          {
            "choice_id": "arrival.choice_04_坐在车站缓一缓",
            "failure_effects": {
              "money": -25.0,
              "stress": 4.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "arrived",
            "success_effects": {
              "loneliness": 4.0,
              "money": -25.0,
              "stress": -8.0,
              "visa_progress": -2.0
            },
            "success_rate": 1.0,
            "text": "坐在车站缓一缓"
          }
        ],
        "selected_choice_id": "arrival.choice_02_立刻去超市和_dm_补生活用品"
      },
      "evidence": {
        "decision_request_fingerprint": "91283825fd72f58d3d5e84fa988e115e995dd14f485df79bf3fbce5e08d2698b",
        "event_request_fingerprint": "ed1e8d3c1fadc970f24b0df6057177d540d1942d47dc98e4983a3bf8c4f00338",
        "source_line": 1,
        "source_record_sha256": "4d66dd4714fe5c1e1c2b9f552a74b753cee08b513252d4d880f0aebb5584055f"
      },
      "finished": false,
      "full_numeric_delta": {
        "academic_progress": 12,
        "blocked_account_balance": -992,
        "energy": -52,
        "exam_readiness": 17,
        "hunger": 2,
        "language": 19,
        "money": -358,
        "social": 5,
        "stress": 12,
        "unpaid_social_streak": 2,
        "week": 1
      },
      "id": "w1",
      "kind": "actual",
      "risk_guidance": {
        "contract_version": "1.0",
        "evaluator": "RiskEvaluator.get_top_risks",
        "generated_for_week": 2,
        "source": "game_risk_evaluator",
        "top_risks": [
          {
            "body": "还剩 4 周。没有 TestDaF 4x4 或注册材料，本学期会被拖后。",
            "id": "registration",
            "score": 84,
            "suggested_actions": [
              "school_registration",
              "insurance_paperwork",
              "testdaf_exam_germany"
            ],
            "title": "学校注册窗口"
          },
          {
            "body": "当前 TestDaF 2/2/2/2。没过 4x4 会卡注册并增加语言班成本。",
            "id": "testdaf",
            "score": 70,
            "suggested_actions": [
              "language_school_germany",
              "testdaf_exam_germany"
            ],
            "title": "TestDaF 4x4"
          },
          {
            "body": "当前可支配现金 142 EUR，逾期 0 EUR。逾期会推高压力和饥饿，并诱发黑工选择。",
            "id": "money",
            "score": 58,
            "suggested_actions": [
              "rent_talk_extension",
              "budget_call",
              "part_time_job",
              "sell_unused_stuff",
              "cook_at_home"
            ],
            "title": "现金流"
          }
        ]
      },
      "selected_action_ids": [
        "problem_set",
        "library_day",
        "language_school_germany",
        "language_tandem"
      ],
      "state_after": {
        "academic_progress": 22,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 0,
        "blocked_account_balance": 10912,
        "career_progress": 0,
        "cash_shortfall_count": 0,
        "current_week_work_hours": 0,
        "energy": 48,
        "exam_readiness": 28,
        "failed_courses": 0,
        "flags": {
          "arrived_supplied": true,
          "housing_contract_active": true
        },
        "gpa_score": 61,
        "hunger": 27,
        "language": 39,
        "loneliness": 30,
        "money": 142,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 20,
        "stress": 32,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 2,
        "visa_progress": 15,
        "week": 2,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "state_before": {
        "academic_progress": 10,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 0,
        "blocked_account_balance": 11904,
        "career_progress": 0,
        "cash_shortfall_count": 0,
        "current_week_work_hours": 0,
        "energy": 100,
        "exam_readiness": 11,
        "failed_courses": 0,
        "flags": {},
        "gpa_score": 61,
        "hunger": 25,
        "language": 20,
        "loneliness": 30,
        "money": 500,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 15,
        "stress": 20,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 0,
        "visa_progress": 15,
        "week": 1,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "week": 1
    },
    {
      "anomalies": [],
      "attractors": [],
      "available_action_ids": [
        "problem_set",
        "library_day",
        "language_tandem",
        "write_email_practice",
        "watch_german_news",
        "insurance_paperwork",
        "bank_account",
        "budget_call",
        "sell_unused_stuff",
        "rent_talk_extension",
        "cook_at_home",
        "student_club",
        "sleep_recover",
        "go_running",
        "bilibili_rest"
      ],
      "decision": {
        "confidence": 1.0,
        "expected_tradeoff": "deterministic fixture authoring choice",
        "risk_awareness": [
          "school_registration_deadline"
        ],
        "strategic_goal": "exercise money priorities"
      },
      "delta": {
        "academic_progress": 14,
        "energy": -16,
        "exam_readiness": 17,
        "hunger": 12,
        "language": 16,
        "loneliness": 2,
        "money": -142,
        "social": 3,
        "stress": 17,
        "visa_progress": 2
      },
      "event": {
        "id": "germany_language_track_start",
        "legal_choices": [
          {
            "choice_id": "germany_language_track_start.choice_01_报名密集语言班",
            "failure_effects": {
              "language": -1.0,
              "money": -420.0,
              "stress": 2.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "academic_progress": -3.0,
              "language": 10.0,
              "money": -420.0,
              "stress": 6.0
            },
            "success_rate": 1.0,
            "text": "报名密集语言班"
          },
          {
            "choice_id": "germany_language_track_start.choice_02_先自学一周省钱",
            "failure_effects": {
              "language": -1.0,
              "money": -35.0,
              "stress": 2.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "academic_progress": -4.0,
              "language": 4.0,
              "money": 40.0,
              "stress": 5.0
            },
            "success_rate": 1.0,
            "text": "先自学一周省钱"
          },
          {
            "choice_id": "germany_language_track_start.choice_03_问学校能否条件注册",
            "failure_effects": {
              "stress": 8.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "stress": 4.0,
              "visa_progress": 3.0
            },
            "success_rate": 0.506,
            "text": "问学校能否条件注册"
          },
          {
            "choice_id": "germany_language_track_start.choice_04_找便宜语言学校",
            "failure_effects": {
              "language": 2.0,
              "money": -220.0,
              "stress": 12.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "language": 6.0,
              "money": -260.0,
              "stress": 8.0
            },
            "success_rate": 0.606,
            "text": "找便宜语言学校"
          }
        ],
        "selected_choice_id": "germany_language_track_start.choice_04_找便宜语言学校"
      },
      "evidence": {
        "decision_request_fingerprint": "5463869ce106678994b67d90e0fea5eff4f81446a0996ce918ac6766efc6db14",
        "event_request_fingerprint": "ff4f263e309d2aa9a57b01e9ebb9d38ea4367f1e16aab0f932b946d7fd3cc90f",
        "source_line": 2,
        "source_record_sha256": "5d3b667da951bd9948243ebb3a6f7346b36a5b27e24b7bf7b44351c139102bc5"
      },
      "finished": false,
      "full_numeric_delta": {
        "academic_progress": 14,
        "arrears_amount": 373,
        "cash_shortfall_count": 2,
        "energy": -16,
        "exam_readiness": 17,
        "hunger": 12,
        "language": 16,
        "loneliness": 2,
        "money": -142,
        "social": 3,
        "stress": 17,
        "unpaid_social_streak": 2,
        "visa_progress": 2,
        "week": 1
      },
      "id": "w2",
      "kind": "actual",
      "risk_guidance": {
        "contract_version": "1.0",
        "evaluator": "RiskEvaluator.get_top_risks",
        "generated_for_week": 3,
        "source": "game_risk_evaluator",
        "top_risks": [
          {
            "body": "还剩 3 周。没有 TestDaF 4x4 或注册材料，本学期会被拖后。",
            "id": "registration",
            "score": 91,
            "suggested_actions": [
              "school_registration",
              "insurance_paperwork",
              "testdaf_exam_germany"
            ],
            "title": "学校注册窗口"
          },
          {
            "body": "当前可支配现金 0 EUR，逾期 373 EUR。逾期会推高压力和饥饿，并诱发黑工选择。",
            "id": "money",
            "score": 78,
            "suggested_actions": [
              "rent_talk_extension",
              "budget_call",
              "part_time_job",
              "sell_unused_stuff",
              "cook_at_home"
            ],
            "title": "现金流"
          },
          {
            "body": "当前 TestDaF 2/2/2/2。没过 4x4 会卡注册并增加语言班成本。",
            "id": "testdaf",
            "score": 70,
            "suggested_actions": [
              "language_school_germany",
              "testdaf_exam_germany"
            ],
            "title": "TestDaF 4x4"
          }
        ]
      },
      "selected_action_ids": [
        "problem_set",
        "library_day",
        "language_tandem",
        "write_email_practice"
      ],
      "state_after": {
        "academic_progress": 36,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 373,
        "blocked_account_balance": 10912,
        "career_progress": 0,
        "cash_shortfall_count": 2,
        "current_week_work_hours": 0,
        "energy": 32,
        "exam_readiness": 45,
        "failed_courses": 0,
        "flags": {
          "arrears": true,
          "arrived_supplied": true,
          "cash_shortfall": true,
          "housing_contract_active": true,
          "shallow_friendships": true
        },
        "gpa_score": 61,
        "hunger": 39,
        "language": 55,
        "loneliness": 32,
        "money": 0,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 23,
        "stress": 49,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 4,
        "visa_progress": 17,
        "week": 3,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "state_before": {
        "academic_progress": 22,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 0,
        "blocked_account_balance": 10912,
        "career_progress": 0,
        "cash_shortfall_count": 0,
        "current_week_work_hours": 0,
        "energy": 48,
        "exam_readiness": 28,
        "failed_courses": 0,
        "flags": {
          "arrived_supplied": true,
          "housing_contract_active": true
        },
        "gpa_score": 61,
        "hunger": 27,
        "language": 39,
        "loneliness": 30,
        "money": 142,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 20,
        "stress": 32,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 2,
        "visa_progress": 15,
        "week": 2,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "week": 2
    },
    {
      "anomalies": [
        {
          "evidence": {
            "delta": 33.0,
            "from": 49.0,
            "metric": "stress",
            "replay": {
              "actions": [
                "problem_set",
                "library_day",
                "language_tandem",
                "write_email_practice"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "missing_school_registration",
              "max_weeks": 3,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 3
            },
            "to": 82.0
          },
          "kind": "single_week_spike",
          "message": "`stress` jumped from 49.0 to 82 in a single week (Δ=+33.0).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 3
        },
        {
          "evidence": {
            "delta": 34.0,
            "from": 39.0,
            "metric": "hunger",
            "replay": {
              "actions": [
                "problem_set",
                "library_day",
                "language_tandem",
                "write_email_practice"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "missing_school_registration",
              "max_weeks": 3,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 3
            },
            "to": 73.0
          },
          "kind": "single_week_spike",
          "message": "`hunger` jumped from 39.0 to 73 in a single week (Δ=+34.0).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 3
        }
      ],
      "attractors": [
        "cashflow-stress-attractor"
      ],
      "available_action_ids": [
        "problem_set",
        "library_day",
        "language_tandem",
        "write_email_practice",
        "watch_german_news",
        "insurance_paperwork",
        "bank_account",
        "budget_call",
        "sell_unused_stuff",
        "rent_talk_extension",
        "sleep_recover",
        "go_running",
        "bilibili_rest"
      ],
      "decision": {
        "confidence": 1.0,
        "expected_tradeoff": "deterministic fixture authoring choice",
        "risk_awareness": [
          "school_registration_deadline"
        ],
        "strategic_goal": "exercise money priorities"
      },
      "delta": {
        "academic_progress": 7,
        "energy": -8,
        "exam_readiness": 17,
        "hunger": 34,
        "language": 10,
        "loneliness": 3,
        "social": 1,
        "stress": 33,
        "visa_progress": 2
      },
      "event": {
        "id": "missing_school_registration",
        "legal_choices": [
          {
            "choice_id": "missing_school_registration.choice_02_先找_international_office",
            "failure_effects": {
              "academic_progress": -7.0,
              "stress": 8.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "school_registered",
            "success_effects": {
              "academic_progress": -3.0,
              "stress": 4.0,
              "visa_progress": 3.0
            },
            "success_rate": 0.867,
            "text": "先找 International Office"
          },
          {
            "choice_id": "missing_school_registration.choice_03_只靠自学顶一周",
            "failure_effects": {
              "stress": 2.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "academic_progress": -6.0,
              "hunger": 5.0,
              "stress": 3.0
            },
            "success_rate": 1.0,
            "text": "只靠自学顶一周"
          },
          {
            "choice_id": "missing_school_registration.choice_04_继续拖延",
            "failure_effects": {
              "money": -80.0,
              "stress": 2.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "academic_progress": -10.0,
              "money": -80.0,
              "stress": 8.0
            },
            "success_rate": 1.0,
            "text": "继续拖延"
          }
        ],
        "selected_choice_id": "missing_school_registration.choice_02_先找_international_office"
      },
      "evidence": {
        "decision_request_fingerprint": "b5db648d888e5eec266bdd9008ea61c6f411d08b6ddd29193ac36e91990ff9c3",
        "event_request_fingerprint": "8be0b4401007d6027848b289fb9678047074a51bb33cecab297b883640c6fdf8",
        "source_line": 3,
        "source_record_sha256": "4041083497b465f0c0ebbc8d43661754bc59713ad8e0cad7aa0f63834dee8830"
      },
      "finished": false,
      "full_numeric_delta": {
        "academic_progress": 7,
        "arrears_amount": 255,
        "cash_shortfall_count": 1,
        "energy": -8,
        "exam_readiness": 17,
        "hunger": 34,
        "language": 10,
        "loneliness": 3,
        "social": 1,
        "stress": 33,
        "unpaid_social_streak": 2,
        "visa_progress": 2,
        "week": 1
      },
      "id": "w3",
      "kind": "actual",
      "risk_guidance": {
        "contract_version": "1.0",
        "evaluator": "RiskEvaluator.get_top_risks",
        "generated_for_week": 4,
        "source": "game_risk_evaluator",
        "top_risks": [
          {
            "body": "还剩 2 周。没有 TestDaF 4x4 或注册材料，本学期会被拖后。",
            "id": "registration",
            "score": 98,
            "suggested_actions": [
              "school_registration",
              "insurance_paperwork",
              "testdaf_exam_germany"
            ],
            "title": "学校注册窗口"
          },
          {
            "body": "当前可支配现金 0 EUR，逾期 628 EUR。逾期会推高压力和饥饿，并诱发黑工选择。",
            "id": "money",
            "score": 96,
            "suggested_actions": [
              "rent_talk_extension",
              "budget_call",
              "part_time_job",
              "sell_unused_stuff",
              "cook_at_home"
            ],
            "title": "现金流"
          },
          {
            "body": "压力 82。高压会拖累学业和考试，并可能覆盖普通成功结局。",
            "id": "stress",
            "score": 82,
            "suggested_actions": [
              "take_a_real_break",
              "therapy",
              "sleep_recover",
              "go_running"
            ],
            "title": "压力"
          }
        ]
      },
      "selected_action_ids": [
        "problem_set",
        "library_day",
        "language_tandem",
        "write_email_practice"
      ],
      "state_after": {
        "academic_progress": 43,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 628,
        "blocked_account_balance": 10912,
        "career_progress": 0,
        "cash_shortfall_count": 3,
        "current_week_work_hours": 0,
        "energy": 24,
        "exam_readiness": 62,
        "failed_courses": 0,
        "flags": {
          "arrears": true,
          "arrived_supplied": true,
          "cash_shortfall": true,
          "cashflow_crisis": true,
          "cashflow_warning": true,
          "housing_contract_active": true,
          "no_close_friends": true,
          "shallow_friendships": true
        },
        "gpa_score": 61,
        "hunger": 73,
        "language": 65,
        "loneliness": 35,
        "money": 0,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 24,
        "stress": 82,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 6,
        "visa_progress": 19,
        "week": 4,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "state_before": {
        "academic_progress": 36,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 373,
        "blocked_account_balance": 10912,
        "career_progress": 0,
        "cash_shortfall_count": 2,
        "current_week_work_hours": 0,
        "energy": 32,
        "exam_readiness": 45,
        "failed_courses": 0,
        "flags": {
          "arrears": true,
          "arrived_supplied": true,
          "cash_shortfall": true,
          "housing_contract_active": true,
          "shallow_friendships": true
        },
        "gpa_score": 61,
        "hunger": 39,
        "language": 55,
        "loneliness": 32,
        "money": 0,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 23,
        "stress": 49,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 4,
        "visa_progress": 17,
        "week": 3,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "week": 3
    },
    {
      "anomalies": [
        {
          "evidence": {
            "delta": 33.0,
            "from": 49.0,
            "metric": "stress",
            "replay": {
              "actions": [
                "problem_set",
                "library_day",
                "language_tandem",
                "write_email_practice"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "missing_school_registration",
              "max_weeks": 4,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 3
            },
            "to": 82.0
          },
          "kind": "single_week_spike",
          "message": "`stress` jumped from 49.0 to 82 in a single week (Δ=+33.0).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 3
        },
        {
          "evidence": {
            "delta": 34.0,
            "from": 39.0,
            "metric": "hunger",
            "replay": {
              "actions": [
                "problem_set",
                "library_day",
                "language_tandem",
                "write_email_practice"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "missing_school_registration",
              "max_weeks": 4,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 3
            },
            "to": 73.0
          },
          "kind": "single_week_spike",
          "message": "`hunger` jumped from 39.0 to 73 in a single week (Δ=+34.0).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 3
        }
      ],
      "attractors": [
        "burnout-risk"
      ],
      "available_action_ids": [
        "problem_set",
        "library_day",
        "language_tandem",
        "write_email_practice",
        "watch_german_news",
        "insurance_paperwork",
        "bank_account",
        "anmeldung",
        "budget_call",
        "sell_unused_stuff",
        "rent_talk_extension",
        "sleep_recover",
        "go_running",
        "take_a_real_break",
        "bilibili_rest"
      ],
      "decision": {
        "confidence": 1.0,
        "expected_tradeoff": "deterministic fixture authoring choice",
        "risk_awareness": [
          "school_registration_deadline",
          "stress"
        ],
        "strategic_goal": "exercise money priorities"
      },
      "delta": {
        "academic_progress": 10,
        "energy": -8,
        "exam_readiness": 17,
        "hunger": 27,
        "language": 10,
        "loneliness": 3,
        "social": 4,
        "stress": 18,
        "visa_progress": 8
      },
      "event": {
        "id": "wg_interview",
        "legal_choices": [
          {
            "choice_id": "wg_interview.choice_01_表现得非常德式",
            "failure_effects": {
              "stress": 5.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "housing_stable",
            "success_effects": {
              "social": 3.0,
              "visa_progress": 6.0
            },
            "success_rate": 0.716,
            "text": "表现得非常德式"
          },
          {
            "choice_id": "wg_interview.choice_02_说自己会做中餐",
            "failure_effects": {
              "stress": 3.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "wg_cooking",
            "success_effects": {
              "hunger": -6.0,
              "loneliness": -4.0,
              "social": 7.0
            },
            "success_rate": 0.607,
            "text": "说自己会做中餐"
          },
          {
            "choice_id": "wg_interview.choice_03_坦白预算很紧",
            "failure_effects": {
              "social": -3.0,
              "stress": 8.0
            },
            "next_event_id": "",
            "requirements": {
              "social": 0.003
            },
            "set_flag": "cheap_room_hint",
            "success_effects": {
              "money": 120.0,
              "stress": 5.0
            },
            "success_rate": 0.266,
            "text": "坦白预算很紧"
          },
          {
            "choice_id": "wg_interview.choice_04_过度迎合每条规则",
            "failure_effects": {
              "stress": 12.0
            },
            "next_event_id": "",
            "requirements": {
              "language": 0.002
            },
            "set_flag": "housing_stable",
            "success_effects": {
              "energy": -6.0,
              "social": 2.0,
              "stress": 8.0
            },
            "success_rate": 0.411,
            "text": "过度迎合每条规则"
          }
        ],
        "selected_choice_id": "wg_interview.choice_01_表现得非常德式"
      },
      "evidence": {
        "decision_request_fingerprint": "1d440273ae907e64e51f73ca6cc9fe91ea5a8a4d806802415c51982e89b3fc1a",
        "event_request_fingerprint": "ce1ac5fa8be878d29e6922c6d84ddd99c82466fbf074a64f11d4f0dba3817c04",
        "source_line": 4,
        "source_record_sha256": "3dd17982ad1f6c1a00542b2bf84df2aa2dcdc70958cef44d64ab74f4f7dbed2f"
      },
      "finished": false,
      "full_numeric_delta": {
        "academic_progress": 10,
        "arrears_amount": 255,
        "cash_shortfall_count": 1,
        "energy": -8,
        "exam_readiness": 17,
        "hunger": 27,
        "language": 10,
        "loneliness": 3,
        "social": 4,
        "stress": 18,
        "unpaid_social_streak": 2,
        "visa_progress": 8,
        "week": 1
      },
      "id": "w4",
      "kind": "actual",
      "risk_guidance": {
        "contract_version": "1.0",
        "evaluator": "RiskEvaluator.get_top_risks",
        "generated_for_week": 5,
        "source": "game_risk_evaluator",
        "top_risks": [
          {
            "body": "还剩 1 周。没有 TestDaF 4x4 或注册材料，本学期会被拖后。",
            "id": "registration",
            "score": 100,
            "suggested_actions": [
              "school_registration",
              "insurance_paperwork",
              "testdaf_exam_germany"
            ],
            "title": "学校注册窗口"
          },
          {
            "body": "压力 100。高压会拖累学业和考试，并可能覆盖普通成功结局。",
            "id": "stress",
            "score": 100,
            "suggested_actions": [
              "take_a_real_break",
              "therapy",
              "sleep_recover",
              "go_running"
            ],
            "title": "压力"
          },
          {
            "body": "饥饿 100。吃饭问题会持续扣精力、加压力、拖学业。",
            "id": "hunger",
            "score": 100,
            "suggested_actions": [
              "cook_at_home",
              "cheap_noodle_week",
              "mensa_coupon",
              "classmate_meal",
              "wg_dinner"
            ],
            "title": "饥饿/生活"
          }
        ]
      },
      "selected_action_ids": [
        "problem_set",
        "library_day",
        "language_tandem",
        "write_email_practice"
      ],
      "state_after": {
        "academic_progress": 53,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 883,
        "blocked_account_balance": 10912,
        "career_progress": 0,
        "cash_shortfall_count": 4,
        "current_week_work_hours": 0,
        "energy": 16,
        "exam_readiness": 79,
        "failed_courses": 0,
        "flags": {
          "arrears": true,
          "arrived_supplied": true,
          "cash_shortfall": true,
          "cashflow_crisis": true,
          "cashflow_warning": true,
          "housing_contract_active": true,
          "housing_stable": true,
          "no_close_friends": true,
          "shallow_friendships": true
        },
        "gpa_score": 61,
        "hunger": 100,
        "language": 75,
        "loneliness": 38,
        "money": 0,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 28,
        "stress": 100,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 8,
        "visa_progress": 27,
        "week": 5,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "state_before": {
        "academic_progress": 43,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 628,
        "blocked_account_balance": 10912,
        "career_progress": 0,
        "cash_shortfall_count": 3,
        "current_week_work_hours": 0,
        "energy": 24,
        "exam_readiness": 62,
        "failed_courses": 0,
        "flags": {
          "arrears": true,
          "arrived_supplied": true,
          "cash_shortfall": true,
          "cashflow_crisis": true,
          "cashflow_warning": true,
          "housing_contract_active": true,
          "no_close_friends": true,
          "shallow_friendships": true
        },
        "gpa_score": 61,
        "hunger": 73,
        "language": 65,
        "loneliness": 35,
        "money": 0,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 24,
        "stress": 82,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 6,
        "visa_progress": 19,
        "week": 4,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "week": 4
    },
    {
      "anomalies": [
        {
          "evidence": {
            "delta": 33.0,
            "from": 49.0,
            "metric": "stress",
            "replay": {
              "actions": [
                "problem_set",
                "library_day",
                "language_tandem",
                "write_email_practice"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "missing_school_registration",
              "max_weeks": 5,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 3
            },
            "to": 82.0
          },
          "kind": "single_week_spike",
          "message": "`stress` jumped from 49.0 to 82 in a single week (Δ=+33.0).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 3
        },
        {
          "evidence": {
            "delta": 34.0,
            "from": 39.0,
            "metric": "hunger",
            "replay": {
              "actions": [
                "problem_set",
                "library_day",
                "language_tandem",
                "write_email_practice"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "missing_school_registration",
              "max_weeks": 5,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 3
            },
            "to": 73.0
          },
          "kind": "single_week_spike",
          "message": "`hunger` jumped from 39.0 to 73 in a single week (Δ=+34.0).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 3
        }
      ],
      "attractors": [],
      "available_action_ids": [
        "problem_set",
        "library_day",
        "language_tandem",
        "write_email_practice",
        "watch_german_news",
        "insurance_paperwork",
        "bank_account",
        "anmeldung",
        "international_office",
        "scholarship",
        "budget_call",
        "sell_unused_stuff",
        "rent_talk_extension",
        "sleep_recover",
        "go_running",
        "take_a_real_break",
        "bilibili_rest"
      ],
      "decision": {
        "confidence": 1.0,
        "expected_tradeoff": "deterministic fixture authoring choice",
        "risk_awareness": [
          "school_registration_deadline",
          "hunger",
          "stress"
        ],
        "strategic_goal": "exercise money priorities"
      },
      "delta": {
        "academic_progress": 7,
        "exam_readiness": 17,
        "language": 10,
        "loneliness": 3,
        "money": 117,
        "social": 1,
        "visa_progress": 5
      },
      "event": {
        "id": "legal_work_limit_notice",
        "legal_choices": [
          {
            "choice_id": "legal_work_limit_notice.choice_01_把工时记进日历",
            "failure_effects": {
              "stress": 2.0,
              "visa_progress": -1.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "work_law_briefed",
            "success_effects": {
              "stress": 2.0,
              "visa_progress": 3.0
            },
            "success_rate": 1.0,
            "text": "把工时记进日历"
          },
          {
            "choice_id": "legal_work_limit_notice.choice_02_只接合同清楚的班",
            "failure_effects": {
              "career_progress": -1.0,
              "money": -40.0,
              "stress": 2.0,
              "visa_progress": -1.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "work_law_briefed",
            "success_effects": {
              "career_progress": 3.0,
              "money": -40.0,
              "visa_progress": 2.0
            },
            "success_rate": 1.0,
            "text": "只接合同清楚的班"
          },
          {
            "choice_id": "legal_work_limit_notice.choice_03_问_asta/international_office",
            "failure_effects": {
              "language": -1.0,
              "stress": 4.0,
              "visa_progress": -1.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "work_law_briefed",
            "success_effects": {
              "language": 2.0,
              "stress": -1.0,
              "visa_progress": 4.0
            },
            "success_rate": 1.0,
            "text": "问 AStA/International Office"
          },
          {
            "choice_id": "legal_work_limit_notice.choice_04_觉得自己不会超",
            "failure_effects": {
              "stress": 4.0,
              "visa_progress": -2.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "work_law_briefed",
            "success_effects": {
              "stress": -2.0
            },
            "success_rate": 0.316,
            "text": "觉得自己不会超"
          }
        ],
        "selected_choice_id": "legal_work_limit_notice.choice_01_把工时记进日历"
      },
      "evidence": {
        "decision_request_fingerprint": "bf4531920350d3f017b148f2219d984b02be09c2b44e1bfc4207cea46cb7fa1a",
        "event_request_fingerprint": "31e611b55c05eb7c18fb325de841cedc8fb06e4bdd58668f29f7e82aa071ebad",
        "source_line": 5,
        "source_record_sha256": "197bad8ffd43d87ec0e2843fc1421d82686b3723a7cb674fc4e3e5dc20f1c0bf"
      },
      "finished": false,
      "full_numeric_delta": {
        "academic_progress": 7,
        "blocked_account_balance": -992,
        "exam_readiness": 17,
        "language": 10,
        "loneliness": 3,
        "money": 117,
        "social": 1,
        "unpaid_social_streak": 2,
        "visa_progress": 5,
        "week": 1
      },
      "id": "w5",
      "kind": "actual",
      "risk_guidance": {
        "contract_version": "1.0",
        "evaluator": "RiskEvaluator.get_top_risks",
        "generated_for_week": 6,
        "source": "game_risk_evaluator",
        "top_risks": [
          {
            "body": "还剩 0 周。没有 TestDaF 4x4 或注册材料，本学期会被拖后。",
            "id": "registration",
            "score": 100,
            "suggested_actions": [
              "school_registration",
              "insurance_paperwork",
              "testdaf_exam_germany"
            ],
            "title": "学校注册窗口"
          },
          {
            "body": "压力 100。高压会拖累学业和考试，并可能覆盖普通成功结局。",
            "id": "stress",
            "score": 100,
            "suggested_actions": [
              "take_a_real_break",
              "therapy",
              "sleep_recover",
              "go_running"
            ],
            "title": "压力"
          },
          {
            "body": "饥饿 100。吃饭问题会持续扣精力、加压力、拖学业。",
            "id": "hunger",
            "score": 100,
            "suggested_actions": [
              "cook_at_home",
              "cheap_noodle_week",
              "mensa_coupon",
              "classmate_meal",
              "wg_dinner"
            ],
            "title": "饥饿/生活"
          }
        ]
      },
      "selected_action_ids": [
        "problem_set",
        "library_day",
        "language_tandem",
        "write_email_practice"
      ],
      "state_after": {
        "academic_progress": 60,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 883,
        "blocked_account_balance": 9920,
        "career_progress": 0,
        "cash_shortfall_count": 4,
        "current_week_work_hours": 0,
        "energy": 16,
        "exam_readiness": 96,
        "failed_courses": 0,
        "flags": {
          "arrears": true,
          "arrived_supplied": true,
          "cash_shortfall": true,
          "cashflow_crisis": true,
          "cashflow_warning": true,
          "housing_contract_active": true,
          "housing_stable": true,
          "no_close_friends": true,
          "shallow_friendships": true,
          "work_law_briefed": true
        },
        "gpa_score": 61,
        "hunger": 100,
        "language": 85,
        "loneliness": 41,
        "money": 117,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 29,
        "stress": 100,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 10,
        "visa_progress": 32,
        "week": 6,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "state_before": {
        "academic_progress": 53,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 883,
        "blocked_account_balance": 10912,
        "career_progress": 0,
        "cash_shortfall_count": 4,
        "current_week_work_hours": 0,
        "energy": 16,
        "exam_readiness": 79,
        "failed_courses": 0,
        "flags": {
          "arrears": true,
          "arrived_supplied": true,
          "cash_shortfall": true,
          "cashflow_crisis": true,
          "cashflow_warning": true,
          "housing_contract_active": true,
          "housing_stable": true,
          "no_close_friends": true,
          "shallow_friendships": true
        },
        "gpa_score": 61,
        "hunger": 100,
        "language": 75,
        "loneliness": 38,
        "money": 0,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 28,
        "stress": 100,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 8,
        "visa_progress": 27,
        "week": 5,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "week": 5
    },
    {
      "anomalies": [
        {
          "evidence": {
            "delta": 33.0,
            "from": 49.0,
            "metric": "stress",
            "replay": {
              "actions": [
                "problem_set",
                "library_day",
                "language_tandem",
                "write_email_practice"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "missing_school_registration",
              "max_weeks": 6,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 3
            },
            "to": 82.0
          },
          "kind": "single_week_spike",
          "message": "`stress` jumped from 49.0 to 82 in a single week (Δ=+33.0).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 3
        },
        {
          "evidence": {
            "delta": 34.0,
            "from": 39.0,
            "metric": "hunger",
            "replay": {
              "actions": [
                "problem_set",
                "library_day",
                "language_tandem",
                "write_email_practice"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "missing_school_registration",
              "max_weeks": 6,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 3
            },
            "to": 73.0
          },
          "kind": "single_week_spike",
          "message": "`hunger` jumped from 39.0 to 73 in a single week (Δ=+34.0).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 3
        }
      ],
      "attractors": [],
      "available_action_ids": [
        "problem_set",
        "library_day",
        "language_tandem",
        "write_email_practice",
        "watch_german_news",
        "insurance_paperwork",
        "bank_account",
        "anmeldung",
        "international_office",
        "part_time_job",
        "scholarship",
        "budget_call",
        "sell_unused_stuff",
        "rent_talk_extension",
        "cook_at_home",
        "cheap_noodle_week",
        "mensa_coupon",
        "wg_dinner",
        "student_club",
        "classmate_meal",
        "sleep_recover",
        "go_running",
        "take_a_real_break",
        "bilibili_rest"
      ],
      "decision": {
        "confidence": 1.0,
        "expected_tradeoff": "deterministic fixture authoring choice",
        "risk_awareness": [
          "school_registration_deadline",
          "hunger",
          "stress"
        ],
        "strategic_goal": "exercise money priorities"
      },
      "delta": {
        "academic_progress": 7,
        "exam_readiness": 4,
        "language": 10,
        "loneliness": 3,
        "money": -117,
        "social": 4,
        "visa_progress": 8
      },
      "event": {
        "id": "anmeldung_deadline",
        "legal_choices": [
          {
            "choice_id": "anmeldung_deadline.choice_01_立刻补材料",
            "failure_effects": {
              "energy": -4.0,
              "stress": 2.0,
              "visa_progress": -1.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "energy": -4.0,
              "stress": 4.0,
              "visa_progress": 7.0
            },
            "success_rate": 1.0,
            "text": "立刻补材料"
          },
          {
            "choice_id": "anmeldung_deadline.choice_02_先问_international_office",
            "failure_effects": {
              "language": -1.0,
              "stress": 4.0,
              "visa_progress": -1.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "language": 1.0,
              "stress": -2.0,
              "visa_progress": 5.0
            },
            "success_rate": 1.0,
            "text": "先问 International Office"
          },
          {
            "choice_id": "anmeldung_deadline.choice_03_请室友确认_wohnungsgeberbestätigung",
            "failure_effects": {
              "stress": 6.0,
              "visa_progress": -2.0
            },
            "next_event_id": "",
            "requirements": {
              "language": 0.002,
              "social": 0.003
            },
            "set_flag": "",
            "success_effects": {
              "social": 3.0,
              "stress": 1.0,
              "visa_progress": 6.0
            },
            "success_rate": 0.851,
            "text": "请室友确认 Wohnungsgeberbestätigung"
          },
          {
            "choice_id": "anmeldung_deadline.choice_04_把信封塞进抽屉",
            "failure_effects": {
              "money": -30.0,
              "stress": 4.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "admin_avoidance",
            "success_effects": {
              "money": -30.0,
              "stress": -5.0,
              "visa_progress": -8.0
            },
            "success_rate": 1.0,
            "text": "把信封塞进抽屉"
          }
        ],
        "selected_choice_id": "anmeldung_deadline.choice_03_请室友确认_wohnungsgeberbestätigung"
      },
      "evidence": {
        "decision_request_fingerprint": "6a136fd3cb0e96a38583b1ee9b55092e90ea0d302c7de559e1b204d663e63be3",
        "event_request_fingerprint": "2e1043d2dbf64a806fafdf81c28100534d57e8bcc0fe51c4a948395bc342afa7",
        "source_line": 6,
        "source_record_sha256": "152f8d78406251afec713b8108fa75ff11bd3a300eb302d0155020b543f4d812"
      },
      "finished": false,
      "full_numeric_delta": {
        "academic_progress": 7,
        "arrears_amount": 138,
        "cash_shortfall_count": 1,
        "exam_readiness": 4,
        "language": 10,
        "loneliness": 3,
        "money": -117,
        "social": 4,
        "unpaid_social_streak": 2,
        "visa_progress": 8,
        "week": 1
      },
      "id": "w6",
      "kind": "actual",
      "risk_guidance": {
        "contract_version": "1.0",
        "evaluator": "RiskEvaluator.get_top_risks",
        "generated_for_week": 7,
        "source": "game_risk_evaluator",
        "top_risks": [
          {
            "body": "压力 100。高压会拖累学业和考试，并可能覆盖普通成功结局。",
            "id": "stress",
            "score": 100,
            "suggested_actions": [
              "take_a_real_break",
              "therapy",
              "sleep_recover",
              "go_running"
            ],
            "title": "压力"
          },
          {
            "body": "饥饿 100。吃饭问题会持续扣精力、加压力、拖学业。",
            "id": "hunger",
            "score": 100,
            "suggested_actions": [
              "cook_at_home",
              "cheap_noodle_week",
              "mensa_coupon",
              "classmate_meal",
              "wg_dinner"
            ],
            "title": "饥饿/生活"
          },
          {
            "body": "当前可支配现金 0 EUR，逾期 1021 EUR。逾期会推高压力和饥饿，并诱发黑工选择。",
            "id": "money",
            "score": 96,
            "suggested_actions": [
              "rent_talk_extension",
              "budget_call",
              "part_time_job",
              "sell_unused_stuff",
              "cook_at_home"
            ],
            "title": "现金流"
          }
        ]
      },
      "selected_action_ids": [
        "problem_set",
        "library_day",
        "language_tandem",
        "write_email_practice"
      ],
      "state_after": {
        "academic_progress": 67,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 1021,
        "blocked_account_balance": 9920,
        "career_progress": 0,
        "cash_shortfall_count": 5,
        "current_week_work_hours": 0,
        "energy": 16,
        "exam_readiness": 100,
        "failed_courses": 0,
        "flags": {
          "arrears": true,
          "arrived_supplied": true,
          "cash_shortfall": true,
          "cashflow_crisis": true,
          "cashflow_warning": true,
          "housing_contract_active": true,
          "housing_stable": true,
          "no_close_friends": true,
          "shallow_friendships": true,
          "work_law_briefed": true
        },
        "gpa_score": 61,
        "hunger": 100,
        "language": 95,
        "loneliness": 44,
        "money": 0,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 33,
        "stress": 100,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 12,
        "visa_progress": 40,
        "week": 7,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "state_before": {
        "academic_progress": 60,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 883,
        "blocked_account_balance": 9920,
        "career_progress": 0,
        "cash_shortfall_count": 4,
        "current_week_work_hours": 0,
        "energy": 16,
        "exam_readiness": 96,
        "failed_courses": 0,
        "flags": {
          "arrears": true,
          "arrived_supplied": true,
          "cash_shortfall": true,
          "cashflow_crisis": true,
          "cashflow_warning": true,
          "housing_contract_active": true,
          "housing_stable": true,
          "no_close_friends": true,
          "shallow_friendships": true,
          "work_law_briefed": true
        },
        "gpa_score": 61,
        "hunger": 100,
        "language": 85,
        "loneliness": 41,
        "money": 117,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 29,
        "stress": 100,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 10,
        "visa_progress": 32,
        "week": 6,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "week": 6
    },
    {
      "anomalies": [
        {
          "evidence": {
            "delta": 33.0,
            "from": 49.0,
            "metric": "stress",
            "replay": {
              "actions": [
                "problem_set",
                "library_day",
                "language_tandem",
                "write_email_practice"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "missing_school_registration",
              "max_weeks": 7,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 3
            },
            "to": 82.0
          },
          "kind": "single_week_spike",
          "message": "`stress` jumped from 49.0 to 82 in a single week (Δ=+33.0).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 3
        },
        {
          "evidence": {
            "delta": 34.0,
            "from": 39.0,
            "metric": "hunger",
            "replay": {
              "actions": [
                "problem_set",
                "library_day",
                "language_tandem",
                "write_email_practice"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "missing_school_registration",
              "max_weeks": 7,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 3
            },
            "to": 73.0
          },
          "kind": "single_week_spike",
          "message": "`hunger` jumped from 39.0 to 73 in a single week (Δ=+34.0).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 3
        }
      ],
      "attractors": [],
      "available_action_ids": [
        "problem_set",
        "library_day",
        "language_tandem",
        "write_email_practice",
        "watch_german_news",
        "insurance_paperwork",
        "bank_account",
        "anmeldung",
        "international_office",
        "part_time_job",
        "scholarship",
        "budget_call",
        "sell_unused_stuff",
        "rent_talk_extension",
        "sleep_recover",
        "go_running",
        "take_a_real_break",
        "bilibili_rest"
      ],
      "decision": {
        "confidence": 1.0,
        "expected_tradeoff": "deterministic fixture authoring choice",
        "risk_awareness": [
          "hunger",
          "stress"
        ],
        "strategic_goal": "exercise money priorities"
      },
      "delta": {
        "academic_progress": -5,
        "language": 5,
        "loneliness": 3,
        "social": 1,
        "visa_progress": 4
      },
      "event": {
        "id": "registration_window_missed",
        "legal_choices": [
          {
            "choice_id": "registration_window_missed.choice_01_接受下学期再注册",
            "failure_effects": {
              "money": -650.0,
              "stress": 2.0,
              "visa_progress": -1.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "registration_delayed",
            "success_effects": {
              "academic_progress": -12.0,
              "money": -650.0,
              "stress": 14.0,
              "visa_progress": 2.0
            },
            "success_rate": 1.0,
            "text": "接受下学期再注册"
          },
          {
            "choice_id": "registration_window_missed.choice_03_转入语言班等待下学期",
            "failure_effects": {
              "language": -1.0,
              "money": -900.0,
              "stress": 2.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "registration_delayed",
            "success_effects": {
              "academic_progress": -9.0,
              "language": 8.0,
              "money": -900.0,
              "stress": 10.0
            },
            "success_rate": 1.0,
            "text": "转入语言班等待下学期"
          },
          {
            "choice_id": "registration_window_missed.choice_04_逃避邮件和截止日",
            "failure_effects": {
              "money": -420.0,
              "stress": 2.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "registration_delayed",
            "success_effects": {
              "academic_progress": -16.0,
              "hunger": 8.0,
              "money": -420.0,
              "stress": 22.0
            },
            "success_rate": 1.0,
            "text": "逃避邮件和截止日"
          }
        ],
        "selected_choice_id": "registration_window_missed.choice_01_接受下学期再注册"
      },
      "evidence": {
        "decision_request_fingerprint": "d334abedd9402af203f0559a410d7f2d58edca3567948d57cd0786b245e2f8c0",
        "event_request_fingerprint": "7f6381b4b98ddd423671bf6ae69e75f76142d9a9b65eece389864aeb7fa050ac",
        "source_line": 7,
        "source_record_sha256": "ad75ae06e0b2979d6e28be8edff328a6482d220f4e73aa067a83a65382cad507"
      },
      "finished": false,
      "full_numeric_delta": {
        "academic_progress": -5,
        "arrears_amount": 905,
        "cash_shortfall_count": 2,
        "language": 5,
        "loneliness": 3,
        "social": 1,
        "unpaid_social_streak": 2,
        "visa_progress": 4,
        "week": 1
      },
      "id": "w7",
      "kind": "actual",
      "risk_guidance": {
        "contract_version": "1.0",
        "evaluator": "RiskEvaluator.get_top_risks",
        "generated_for_week": 8,
        "source": "game_risk_evaluator",
        "top_risks": [
          {
            "body": "压力 100。高压会拖累学业和考试，并可能覆盖普通成功结局。",
            "id": "stress",
            "score": 100,
            "suggested_actions": [
              "take_a_real_break",
              "therapy",
              "sleep_recover",
              "go_running"
            ],
            "title": "压力"
          },
          {
            "body": "饥饿 100。吃饭问题会持续扣精力、加压力、拖学业。",
            "id": "hunger",
            "score": 100,
            "suggested_actions": [
              "cook_at_home",
              "cheap_noodle_week",
              "mensa_coupon",
              "classmate_meal",
              "wg_dinner"
            ],
            "title": "饥饿/生活"
          },
          {
            "body": "当前可支配现金 0 EUR，逾期 1926 EUR。逾期会推高压力和饥饿，并诱发黑工选择。",
            "id": "money",
            "score": 96,
            "suggested_actions": [
              "rent_talk_extension",
              "budget_call",
              "part_time_job",
              "sell_unused_stuff",
              "cook_at_home"
            ],
            "title": "现金流"
          }
        ]
      },
      "selected_action_ids": [
        "problem_set",
        "library_day",
        "language_tandem",
        "write_email_practice"
      ],
      "state_after": {
        "academic_progress": 62,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 1926,
        "blocked_account_balance": 9920,
        "career_progress": 0,
        "cash_shortfall_count": 7,
        "current_week_work_hours": 0,
        "energy": 16,
        "exam_readiness": 100,
        "failed_courses": 0,
        "flags": {
          "arrears": true,
          "arrived_supplied": true,
          "cash_shortfall": true,
          "cashflow_crisis": true,
          "cashflow_warning": true,
          "housing_contract_active": true,
          "housing_stable": true,
          "no_close_friends": true,
          "registration_delayed": true,
          "shallow_friendships": true,
          "work_law_briefed": true
        },
        "gpa_score": 61,
        "hunger": 100,
        "language": 100,
        "loneliness": 47,
        "money": 0,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 34,
        "stress": 100,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 14,
        "visa_progress": 44,
        "week": 8,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "state_before": {
        "academic_progress": 67,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 1021,
        "blocked_account_balance": 9920,
        "career_progress": 0,
        "cash_shortfall_count": 5,
        "current_week_work_hours": 0,
        "energy": 16,
        "exam_readiness": 100,
        "failed_courses": 0,
        "flags": {
          "arrears": true,
          "arrived_supplied": true,
          "cash_shortfall": true,
          "cashflow_crisis": true,
          "cashflow_warning": true,
          "housing_contract_active": true,
          "housing_stable": true,
          "no_close_friends": true,
          "shallow_friendships": true,
          "work_law_briefed": true
        },
        "gpa_score": 61,
        "hunger": 100,
        "language": 95,
        "loneliness": 44,
        "money": 0,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 33,
        "stress": 100,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 12,
        "visa_progress": 40,
        "week": 7,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "week": 7
    },
    {
      "anomalies": [
        {
          "evidence": {
            "delta": 33.0,
            "from": 49.0,
            "metric": "stress",
            "replay": {
              "actions": [
                "problem_set",
                "library_day",
                "language_tandem",
                "write_email_practice"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "missing_school_registration",
              "max_weeks": 8,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 3
            },
            "to": 82.0
          },
          "kind": "single_week_spike",
          "message": "`stress` jumped from 49.0 to 82 in a single week (Δ=+33.0).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 3
        },
        {
          "evidence": {
            "delta": 34.0,
            "from": 39.0,
            "metric": "hunger",
            "replay": {
              "actions": [
                "problem_set",
                "library_day",
                "language_tandem",
                "write_email_practice"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "missing_school_registration",
              "max_weeks": 8,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 3
            },
            "to": 73.0
          },
          "kind": "single_week_spike",
          "message": "`hunger` jumped from 39.0 to 73 in a single week (Δ=+34.0).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 3
        }
      ],
      "attractors": [],
      "available_action_ids": [
        "problem_set",
        "library_day",
        "language_tandem",
        "write_email_practice",
        "watch_german_news",
        "insurance_paperwork",
        "bank_account",
        "anmeldung",
        "visa_appointment",
        "international_office",
        "write_formal_email_to_abh",
        "part_time_job",
        "scholarship",
        "budget_call",
        "sell_unused_stuff",
        "rent_talk_extension",
        "sleep_recover",
        "go_running",
        "take_a_real_break",
        "bilibili_rest"
      ],
      "decision": {
        "confidence": 1.0,
        "expected_tradeoff": "deterministic fixture authoring choice",
        "risk_awareness": [
          "registration_delayed",
          "hunger",
          "stress"
        ],
        "strategic_goal": "exercise money priorities"
      },
      "delta": {
        "academic_progress": 7,
        "social": 1,
        "visa_progress": 2
      },
      "event": {
        "id": "parents_money_hint",
        "legal_choices": [
          {
            "choice_id": "parents_money_hint.choice_01_做预算表给他们看",
            "failure_effects": {
              "money": -35.0,
              "stress": 2.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "money": 120.0,
              "stress": 3.0
            },
            "success_rate": 1.0,
            "text": "做预算表给他们看"
          },
          {
            "choice_id": "parents_money_hint.choice_02_先安慰他们",
            "failure_effects": {
              "loneliness": 2.0,
              "stress": 2.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "loneliness": -3.0,
              "stress": 2.0
            },
            "success_rate": 1.0,
            "text": "先安慰他们"
          },
          {
            "choice_id": "parents_money_hint.choice_03_稳妥处理",
            "failure_effects": {
              "money": 35.0,
              "stress": 4.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "money": 105.0,
              "stress": 1.0
            },
            "success_rate": 0.412,
            "text": "稳妥处理"
          },
          {
            "choice_id": "parents_money_hint.choice_04_寻求帮助",
            "failure_effects": {
              "social": -1.0,
              "stress": 3.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "money": 70.0,
              "social": 2.0,
              "stress": -2.0
            },
            "success_rate": 0.636,
            "text": "寻求帮助"
          }
        ],
        "selected_choice_id": "parents_money_hint.choice_02_先安慰他们"
      },
      "evidence": {
        "decision_request_fingerprint": "05b7065a5890d9127989ec6c1c3b89f08b939ee11a6ee1d96ae8ddc3035fc042",
        "event_request_fingerprint": "1c8b7c95854e0637bdf8a7a103942205d551a4943860ab6a76772bebed38bb3d",
        "source_line": 8,
        "source_record_sha256": "1c2e0340282e34687553ddcd2c5f3d7e69a6201d37914ff5c70bcbb401ea641d"
      },
      "finished": false,
      "full_numeric_delta": {
        "academic_progress": 7,
        "arrears_amount": 255,
        "cash_shortfall_count": 1,
        "social": 1,
        "unpaid_social_streak": 2,
        "visa_progress": 2,
        "week": 1
      },
      "id": "w8",
      "kind": "actual",
      "risk_guidance": {
        "contract_version": "1.0",
        "evaluator": "RiskEvaluator.get_top_risks",
        "generated_for_week": 9,
        "source": "game_risk_evaluator",
        "top_risks": [
          {
            "body": "压力 100。高压会拖累学业和考试，并可能覆盖普通成功结局。",
            "id": "stress",
            "score": 100,
            "suggested_actions": [
              "take_a_real_break",
              "therapy",
              "sleep_recover",
              "go_running"
            ],
            "title": "压力"
          },
          {
            "body": "饥饿 100。吃饭问题会持续扣精力、加压力、拖学业。",
            "id": "hunger",
            "score": 100,
            "suggested_actions": [
              "cook_at_home",
              "cheap_noodle_week",
              "mensa_coupon",
              "classmate_meal",
              "wg_dinner"
            ],
            "title": "饥饿/生活"
          },
          {
            "body": "当前可支配现金 0 EUR，逾期 2181 EUR。逾期会推高压力和饥饿，并诱发黑工选择。",
            "id": "money",
            "score": 96,
            "suggested_actions": [
              "rent_talk_extension",
              "budget_call",
              "part_time_job",
              "sell_unused_stuff",
              "cook_at_home"
            ],
            "title": "现金流"
          }
        ]
      },
      "selected_action_ids": [
        "problem_set",
        "library_day",
        "language_tandem",
        "write_email_practice"
      ],
      "state_after": {
        "academic_progress": 69,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 2181,
        "blocked_account_balance": 9920,
        "career_progress": 0,
        "cash_shortfall_count": 8,
        "current_week_work_hours": 0,
        "energy": 16,
        "exam_readiness": 100,
        "failed_courses": 0,
        "flags": {
          "arrears": true,
          "arrived_supplied": true,
          "cash_shortfall": true,
          "cashflow_crisis": true,
          "cashflow_warning": true,
          "housing_contract_active": true,
          "housing_stable": true,
          "no_close_friends": true,
          "registration_delayed": true,
          "shallow_friendships": true,
          "work_law_briefed": true
        },
        "gpa_score": 61,
        "hunger": 100,
        "language": 100,
        "loneliness": 47,
        "money": 0,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 35,
        "stress": 100,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 16,
        "visa_progress": 46,
        "week": 9,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "state_before": {
        "academic_progress": 62,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 1926,
        "blocked_account_balance": 9920,
        "career_progress": 0,
        "cash_shortfall_count": 7,
        "current_week_work_hours": 0,
        "energy": 16,
        "exam_readiness": 100,
        "failed_courses": 0,
        "flags": {
          "arrears": true,
          "arrived_supplied": true,
          "cash_shortfall": true,
          "cashflow_crisis": true,
          "cashflow_warning": true,
          "housing_contract_active": true,
          "housing_stable": true,
          "no_close_friends": true,
          "registration_delayed": true,
          "shallow_friendships": true,
          "work_law_briefed": true
        },
        "gpa_score": 61,
        "hunger": 100,
        "language": 100,
        "loneliness": 47,
        "money": 0,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 34,
        "stress": 100,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 14,
        "visa_progress": 44,
        "week": 8,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "week": 8
    },
    {
      "anomalies": [
        {
          "evidence": {
            "delta": 33.0,
            "from": 49.0,
            "metric": "stress",
            "replay": {
              "actions": [
                "problem_set",
                "library_day",
                "language_tandem",
                "write_email_practice"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "missing_school_registration",
              "max_weeks": 9,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 3
            },
            "to": 82.0
          },
          "kind": "single_week_spike",
          "message": "`stress` jumped from 49.0 to 82 in a single week (Δ=+33.0).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 3
        },
        {
          "evidence": {
            "delta": 34.0,
            "from": 39.0,
            "metric": "hunger",
            "replay": {
              "actions": [
                "problem_set",
                "library_day",
                "language_tandem",
                "write_email_practice"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "missing_school_registration",
              "max_weeks": 9,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 3
            },
            "to": 73.0
          },
          "kind": "single_week_spike",
          "message": "`hunger` jumped from 39.0 to 73 in a single week (Δ=+34.0).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 3
        },
        {
          "evidence": {
            "replay": {
              "actions": [
                "problem_set",
                "library_day",
                "language_tandem",
                "write_email_practice"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "exam_registration",
              "max_weeks": 9,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 9
            },
            "streak_weeks": 6,
            "threshold": 85.0
          },
          "kind": "hunger_ignored_too_long",
          "message": "Hunger ≥ 85 for 6 consecutive weeks (week=9).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 9
        }
      ],
      "attractors": [],
      "available_action_ids": [
        "problem_set",
        "library_day",
        "language_tandem",
        "write_email_practice",
        "watch_german_news",
        "bank_account",
        "anmeldung",
        "visa_appointment",
        "international_office",
        "write_formal_email_to_abh",
        "part_time_job",
        "scholarship",
        "budget_call",
        "sell_unused_stuff",
        "rent_talk_extension",
        "sleep_recover",
        "go_running",
        "take_a_real_break",
        "bilibili_rest",
        "cv_workshop"
      ],
      "decision": {
        "confidence": 1.0,
        "expected_tradeoff": "deterministic fixture authoring choice",
        "risk_awareness": [
          "registration_delayed",
          "hunger",
          "stress"
        ],
        "strategic_goal": "exercise money priorities"
      },
      "delta": {
        "academic_progress": 7,
        "exam_readiness": -4,
        "loneliness": 3,
        "money": 117,
        "social": 1,
        "visa_progress": 2
      },
      "event": {
        "id": "exam_registration",
        "legal_choices": [
          {
            "choice_id": "exam_registration.choice_01_马上报名",
            "failure_effects": {
              "academic_progress": -1.0,
              "stress": 4.0,
              "visa_progress": -1.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "exam_registered",
            "success_effects": {
              "academic_progress": 2.0,
              "exam_readiness": 4.0,
              "stress": -3.0,
              "visa_progress": 2.0
            },
            "success_rate": 1.0,
            "text": "马上报名"
          },
          {
            "choice_id": "exam_registration.choice_02_报名后顺手查考纲",
            "failure_effects": {
              "academic_progress": -1.0,
              "stress": 2.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "exam_registered",
            "success_effects": {
              "academic_progress": 1.0,
              "exam_readiness": 7.0,
              "stress": 1.0
            },
            "success_rate": 1.0,
            "text": "报名后顺手查考纲"
          },
          {
            "choice_id": "exam_registration.choice_03_先问同学报名流程",
            "failure_effects": {
              "stress": 5.0
            },
            "next_event_id": "",
            "requirements": {
              "social": 0.003
            },
            "set_flag": "exam_registered",
            "success_effects": {
              "exam_readiness": 3.0,
              "social": 3.0,
              "stress": 1.0
            },
            "success_rate": 0.644,
            "text": "先问同学报名流程"
          },
          {
            "choice_id": "exam_registration.choice_04_晚点再说",
            "failure_effects": {
              "stress": 2.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "exam_readiness": -4.0,
              "stress": 5.0
            },
            "success_rate": 1.0,
            "text": "晚点再说"
          }
        ],
        "selected_choice_id": "exam_registration.choice_04_晚点再说"
      },
      "evidence": {
        "decision_request_fingerprint": "d9dc4ee75063e70f92922d0a96e914bb51c659030bd08e0a3ef3a5f51fd6d82f",
        "event_request_fingerprint": "b98e493766fc13f69c1cc1ff157f8ecfd2adb0e56bfff851c935670b4697499c",
        "source_line": 9,
        "source_record_sha256": "fc00306e7f3d4d154572c88025a626c7fd0c9c86052bc8f208e5fe1525f81b12"
      },
      "finished": false,
      "full_numeric_delta": {
        "academic_progress": 7,
        "blocked_account_balance": -992,
        "exam_readiness": -4,
        "loneliness": 3,
        "money": 117,
        "social": 1,
        "unpaid_social_streak": 2,
        "visa_progress": 2,
        "week": 1
      },
      "id": "w9",
      "kind": "actual",
      "risk_guidance": {
        "contract_version": "1.0",
        "evaluator": "RiskEvaluator.get_top_risks",
        "generated_for_week": 10,
        "source": "game_risk_evaluator",
        "top_risks": [
          {
            "body": "压力 100。高压会拖累学业和考试，并可能覆盖普通成功结局。",
            "id": "stress",
            "score": 100,
            "suggested_actions": [
              "take_a_real_break",
              "therapy",
              "sleep_recover",
              "go_running"
            ],
            "title": "压力"
          },
          {
            "body": "饥饿 100。吃饭问题会持续扣精力、加压力、拖学业。",
            "id": "hunger",
            "score": 100,
            "suggested_actions": [
              "cook_at_home",
              "cheap_noodle_week",
              "mensa_coupon",
              "classmate_meal",
              "wg_dinner"
            ],
            "title": "饥饿/生活"
          },
          {
            "body": "当前可支配现金 117 EUR，逾期 2181 EUR。逾期会推高压力和饥饿，并诱发黑工选择。",
            "id": "money",
            "score": 96,
            "suggested_actions": [
              "rent_talk_extension",
              "budget_call",
              "part_time_job",
              "sell_unused_stuff",
              "cook_at_home"
            ],
            "title": "现金流"
          }
        ]
      },
      "selected_action_ids": [
        "problem_set",
        "library_day",
        "language_tandem",
        "write_email_practice"
      ],
      "state_after": {
        "academic_progress": 76,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 2181,
        "blocked_account_balance": 8928,
        "career_progress": 0,
        "cash_shortfall_count": 8,
        "current_week_work_hours": 0,
        "energy": 16,
        "exam_readiness": 96,
        "failed_courses": 0,
        "flags": {
          "arrears": true,
          "arrived_supplied": true,
          "cash_shortfall": true,
          "cashflow_crisis": true,
          "cashflow_warning": true,
          "housing_contract_active": true,
          "housing_stable": true,
          "no_close_friends": true,
          "registration_delayed": true,
          "shallow_friendships": true,
          "work_law_briefed": true
        },
        "gpa_score": 61,
        "hunger": 100,
        "language": 100,
        "loneliness": 50,
        "money": 117,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 36,
        "stress": 100,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 18,
        "visa_progress": 48,
        "week": 10,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "state_before": {
        "academic_progress": 69,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 2181,
        "blocked_account_balance": 9920,
        "career_progress": 0,
        "cash_shortfall_count": 8,
        "current_week_work_hours": 0,
        "energy": 16,
        "exam_readiness": 100,
        "failed_courses": 0,
        "flags": {
          "arrears": true,
          "arrived_supplied": true,
          "cash_shortfall": true,
          "cashflow_crisis": true,
          "cashflow_warning": true,
          "housing_contract_active": true,
          "housing_stable": true,
          "no_close_friends": true,
          "registration_delayed": true,
          "shallow_friendships": true,
          "work_law_briefed": true
        },
        "gpa_score": 61,
        "hunger": 100,
        "language": 100,
        "loneliness": 47,
        "money": 0,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 35,
        "stress": 100,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 16,
        "visa_progress": 46,
        "week": 9,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "week": 9
    },
    {
      "anomalies": [
        {
          "evidence": {
            "delta": 33.0,
            "from": 49.0,
            "metric": "stress",
            "replay": {
              "actions": [
                "problem_set",
                "library_day",
                "language_tandem",
                "write_email_practice"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "missing_school_registration",
              "max_weeks": 10,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 3
            },
            "to": 82.0
          },
          "kind": "single_week_spike",
          "message": "`stress` jumped from 49.0 to 82 in a single week (Δ=+33.0).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 3
        },
        {
          "evidence": {
            "delta": 34.0,
            "from": 39.0,
            "metric": "hunger",
            "replay": {
              "actions": [
                "problem_set",
                "library_day",
                "language_tandem",
                "write_email_practice"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "missing_school_registration",
              "max_weeks": 10,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 3
            },
            "to": 73.0
          },
          "kind": "single_week_spike",
          "message": "`hunger` jumped from 39.0 to 73 in a single week (Δ=+34.0).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 3
        },
        {
          "evidence": {
            "replay": {
              "actions": [
                "problem_set",
                "library_day",
                "language_tandem",
                "write_email_practice"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "midterm_pressure",
              "max_weeks": 10,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 10
            },
            "streak_weeks": 7,
            "threshold": 85.0
          },
          "kind": "hunger_ignored_too_long",
          "message": "Hunger ≥ 85 for 7 consecutive weeks (week=10).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 10
        }
      ],
      "attractors": [],
      "available_action_ids": [
        "problem_set",
        "library_day",
        "language_tandem",
        "write_email_practice",
        "watch_german_news",
        "anmeldung",
        "visa_appointment",
        "international_office",
        "emergency_international_office",
        "write_formal_email_to_abh",
        "part_time_job",
        "mini_job_extra",
        "scholarship",
        "budget_call",
        "sell_unused_stuff",
        "rent_talk_extension",
        "cook_at_home",
        "cheap_noodle_week",
        "mensa_coupon",
        "wg_dinner",
        "student_club",
        "classmate_meal",
        "date_night",
        "sleep_recover",
        "go_running",
        "take_a_real_break",
        "bilibili_rest",
        "cv_workshop"
      ],
      "decision": {
        "confidence": 1.0,
        "expected_tradeoff": "deterministic fixture authoring choice",
        "risk_awareness": [
          "registration_delayed",
          "hunger",
          "stress"
        ],
        "strategic_goal": "exercise money priorities"
      },
      "delta": {
        "academic_progress": 11,
        "energy": -12,
        "exam_readiness": 4,
        "loneliness": 3,
        "money": -117,
        "social": 1,
        "visa_progress": 2
      },
      "event": {
        "id": "midterm_pressure",
        "legal_choices": [
          {
            "choice_id": "midterm_pressure.choice_01_整理学习计划",
            "failure_effects": {
              "academic_progress": -1.0,
              "stress": 4.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "academic_progress": 5.0,
              "exam_readiness": 4.0,
              "stress": -2.0
            },
            "success_rate": 1.0,
            "text": "整理学习计划"
          },
          {
            "choice_id": "midterm_pressure.choice_02_先睡一觉",
            "failure_effects": {
              "energy": -4.0,
              "stress": 4.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "academic_progress": -2.0,
              "energy": 16.0,
              "exam_readiness": -2.0,
              "stress": -6.0
            },
            "success_rate": 1.0,
            "text": "先睡一觉"
          },
          {
            "choice_id": "midterm_pressure.choice_03_砍掉一班打工补作业",
            "failure_effects": {
              "academic_progress": -1.0,
              "money": -139.0,
              "stress": 2.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "academic_progress": 7.0,
              "exam_readiness": 5.0,
              "money": -139.0,
              "stress": 3.0
            },
            "success_rate": 1.0,
            "text": "砍掉一班打工补作业"
          },
          {
            "choice_id": "midterm_pressure.choice_04_靠咖啡硬顶",
            "failure_effects": {
              "academic_progress": -1.0,
              "energy": -12.0,
              "stress": 2.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "academic_progress": 4.0,
              "energy": -12.0,
              "exam_readiness": 2.0,
              "stress": 10.0
            },
            "success_rate": 1.0,
            "text": "靠咖啡硬顶"
          }
        ],
        "selected_choice_id": "midterm_pressure.choice_04_靠咖啡硬顶"
      },
      "evidence": {
        "decision_request_fingerprint": "63d966e2979f07cd557b551a4c6097907ca6ae076abf2fd28098c1acb560b6fe",
        "event_request_fingerprint": "24c2be723ebbda79af7f281782031232b69f23cd714e8ff6d69783f49e72508b",
        "source_line": 10,
        "source_record_sha256": "54fc30dc919c403f854c96387ca2058dc85c96acb25c02383ceb3469df603a17"
      },
      "finished": false,
      "full_numeric_delta": {
        "academic_progress": 11,
        "arrears_amount": 138,
        "cash_shortfall_count": 1,
        "energy": -12,
        "exam_readiness": 4,
        "loneliness": 3,
        "money": -117,
        "social": 1,
        "unpaid_social_streak": 2,
        "visa_progress": 2,
        "week": 1
      },
      "id": "w10",
      "kind": "actual",
      "risk_guidance": {
        "contract_version": "1.0",
        "evaluator": "RiskEvaluator.get_top_risks",
        "generated_for_week": 11,
        "source": "game_risk_evaluator",
        "top_risks": [
          {
            "body": "压力 100。高压会拖累学业和考试，并可能覆盖普通成功结局。",
            "id": "stress",
            "score": 100,
            "suggested_actions": [
              "take_a_real_break",
              "therapy",
              "sleep_recover",
              "go_running"
            ],
            "title": "压力"
          },
          {
            "body": "饥饿 100。吃饭问题会持续扣精力、加压力、拖学业。",
            "id": "hunger",
            "score": 100,
            "suggested_actions": [
              "cook_at_home",
              "cheap_noodle_week",
              "mensa_coupon",
              "classmate_meal",
              "wg_dinner"
            ],
            "title": "饥饿/生活"
          },
          {
            "body": "当前可支配现金 0 EUR，逾期 2319 EUR。逾期会推高压力和饥饿，并诱发黑工选择。",
            "id": "money",
            "score": 96,
            "suggested_actions": [
              "rent_talk_extension",
              "budget_call",
              "part_time_job",
              "sell_unused_stuff",
              "cook_at_home"
            ],
            "title": "现金流"
          }
        ]
      },
      "selected_action_ids": [
        "problem_set",
        "library_day",
        "language_tandem",
        "write_email_practice"
      ],
      "state_after": {
        "academic_progress": 87,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 2319,
        "blocked_account_balance": 8928,
        "career_progress": 0,
        "cash_shortfall_count": 9,
        "current_week_work_hours": 0,
        "energy": 4,
        "exam_readiness": 100,
        "failed_courses": 0,
        "flags": {
          "arrears": true,
          "arrived_supplied": true,
          "cash_shortfall": true,
          "cashflow_crisis": true,
          "cashflow_warning": true,
          "housing_contract_active": true,
          "housing_stable": true,
          "no_close_friends": true,
          "registration_delayed": true,
          "shallow_friendships": true,
          "work_law_briefed": true
        },
        "gpa_score": 61,
        "hunger": 100,
        "language": 100,
        "loneliness": 53,
        "money": 0,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 37,
        "stress": 100,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 20,
        "visa_progress": 50,
        "week": 11,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "state_before": {
        "academic_progress": 76,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 2181,
        "blocked_account_balance": 8928,
        "career_progress": 0,
        "cash_shortfall_count": 8,
        "current_week_work_hours": 0,
        "energy": 16,
        "exam_readiness": 96,
        "failed_courses": 0,
        "flags": {
          "arrears": true,
          "arrived_supplied": true,
          "cash_shortfall": true,
          "cashflow_crisis": true,
          "cashflow_warning": true,
          "housing_contract_active": true,
          "housing_stable": true,
          "no_close_friends": true,
          "registration_delayed": true,
          "shallow_friendships": true,
          "work_law_briefed": true
        },
        "gpa_score": 61,
        "hunger": 100,
        "language": 100,
        "loneliness": 50,
        "money": 117,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 36,
        "stress": 100,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 18,
        "visa_progress": 48,
        "week": 10,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "week": 10
    },
    {
      "anomalies": [
        {
          "evidence": {
            "delta": 33.0,
            "from": 49.0,
            "metric": "stress",
            "replay": {
              "actions": [
                "problem_set",
                "library_day",
                "language_tandem",
                "write_email_practice"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "missing_school_registration",
              "max_weeks": 11,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 3
            },
            "to": 82.0
          },
          "kind": "single_week_spike",
          "message": "`stress` jumped from 49.0 to 82 in a single week (Δ=+33.0).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 3
        },
        {
          "evidence": {
            "delta": 34.0,
            "from": 39.0,
            "metric": "hunger",
            "replay": {
              "actions": [
                "problem_set",
                "library_day",
                "language_tandem",
                "write_email_practice"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "missing_school_registration",
              "max_weeks": 11,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 3
            },
            "to": 73.0
          },
          "kind": "single_week_spike",
          "message": "`hunger` jumped from 39.0 to 73 in a single week (Δ=+34.0).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 3
        },
        {
          "evidence": {
            "replay": {
              "actions": [
                "problem_set",
                "library_day",
                "language_tandem",
                "write_email_practice"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "wechat_silence",
              "max_weeks": 11,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 11
            },
            "streak_weeks": 8,
            "threshold": 85.0
          },
          "kind": "hunger_ignored_too_long",
          "message": "Hunger ≥ 85 for 8 consecutive weeks (week=11).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 11
        }
      ],
      "attractors": [],
      "available_action_ids": [
        "problem_set",
        "library_day",
        "language_tandem",
        "write_email_practice",
        "watch_german_news",
        "visa_appointment",
        "international_office",
        "emergency_international_office",
        "write_formal_email_to_abh",
        "part_time_job",
        "mini_job_extra",
        "scholarship",
        "budget_call",
        "sell_unused_stuff",
        "rent_talk_extension",
        "sleep_recover",
        "go_running",
        "take_a_real_break",
        "bilibili_rest",
        "cv_workshop"
      ],
      "decision": {
        "confidence": 1.0,
        "expected_tradeoff": "deterministic fixture authoring choice",
        "risk_awareness": [
          "registration_delayed",
          "hunger",
          "stress"
        ],
        "strategic_goal": "exercise money priorities"
      },
      "delta": {
        "academic_progress": 6,
        "energy": 12,
        "loneliness": 3,
        "social": 1,
        "visa_progress": 2
      },
      "event": {
        "id": "wechat_silence",
        "legal_choices": [
          {
            "choice_id": "wechat_silence.choice_01_写一段真实记录",
            "failure_effects": {
              "loneliness": 2.0,
              "stress": 4.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "loneliness": -5.0,
              "stress": -2.0
            },
            "success_rate": 1.0,
            "text": "写一段真实记录"
          },
          {
            "choice_id": "wechat_silence.choice_02_继续潜水",
            "failure_effects": {
              "energy": -4.0,
              "stress": 2.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "energy": 2.0,
              "loneliness": 3.0
            },
            "success_rate": 1.0,
            "text": "继续潜水"
          },
          {
            "choice_id": "wechat_silence.choice_03_稳妥处理",
            "failure_effects": {
              "energy": 0.0,
              "stress": 3.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "energy": 1.0,
              "stress": -2.0
            },
            "success_rate": 0.196,
            "text": "稳妥处理"
          },
          {
            "choice_id": "wechat_silence.choice_04_寻求帮助",
            "failure_effects": {
              "social": -1.0,
              "stress": 3.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "energy": 1.0,
              "social": 2.0,
              "stress": -4.0
            },
            "success_rate": 0.42,
            "text": "寻求帮助"
          }
        ],
        "selected_choice_id": "wechat_silence.choice_03_稳妥处理"
      },
      "evidence": {
        "decision_request_fingerprint": "e8a18e6dade9b59e652b2654f21d2b0c13b3b8cb2ea388c83b5a57ee98697256",
        "event_request_fingerprint": "4661e54adc625a54c48ce0e2efcd7e1f246b5058cf72f1dd61266e88b651be8b",
        "source_line": 11,
        "source_record_sha256": "c1fe5fd5242b4e5610e20b515be5a546c811881c2c42e23bbc8b2894d1b854c0"
      },
      "finished": false,
      "full_numeric_delta": {
        "academic_progress": 6,
        "arrears_amount": 255,
        "cash_shortfall_count": 1,
        "energy": 12,
        "loneliness": 3,
        "social": 1,
        "unpaid_social_streak": 2,
        "visa_progress": 2,
        "week": 1
      },
      "id": "w11",
      "kind": "actual",
      "risk_guidance": {
        "contract_version": "1.0",
        "evaluator": "RiskEvaluator.get_top_risks",
        "generated_for_week": 12,
        "source": "game_risk_evaluator",
        "top_risks": [
          {
            "body": "压力 100。高压会拖累学业和考试，并可能覆盖普通成功结局。",
            "id": "stress",
            "score": 100,
            "suggested_actions": [
              "take_a_real_break",
              "therapy",
              "sleep_recover",
              "go_running"
            ],
            "title": "压力"
          },
          {
            "body": "饥饿 100。吃饭问题会持续扣精力、加压力、拖学业。",
            "id": "hunger",
            "score": 100,
            "suggested_actions": [
              "cook_at_home",
              "cheap_noodle_week",
              "mensa_coupon",
              "classmate_meal",
              "wg_dinner"
            ],
            "title": "饥饿/生活"
          },
          {
            "body": "当前可支配现金 0 EUR，逾期 2574 EUR。逾期会推高压力和饥饿，并诱发黑工选择。",
            "id": "money",
            "score": 96,
            "suggested_actions": [
              "rent_talk_extension",
              "budget_call",
              "part_time_job",
              "sell_unused_stuff",
              "cook_at_home"
            ],
            "title": "现金流"
          }
        ]
      },
      "selected_action_ids": [
        "problem_set",
        "library_day",
        "language_tandem",
        "write_email_practice"
      ],
      "state_after": {
        "academic_progress": 93,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 2574,
        "blocked_account_balance": 8928,
        "career_progress": 0,
        "cash_shortfall_count": 10,
        "current_week_work_hours": 0,
        "energy": 16,
        "exam_readiness": 100,
        "failed_courses": 0,
        "flags": {
          "arrears": true,
          "arrived_supplied": true,
          "cash_shortfall": true,
          "cashflow_crisis": true,
          "cashflow_warning": true,
          "housing_contract_active": true,
          "housing_stable": true,
          "no_close_friends": true,
          "registration_delayed": true,
          "shallow_friendships": true,
          "work_law_briefed": true
        },
        "gpa_score": 61,
        "hunger": 100,
        "language": 100,
        "loneliness": 56,
        "money": 0,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 38,
        "stress": 100,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 22,
        "visa_progress": 52,
        "week": 12,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "state_before": {
        "academic_progress": 87,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 2319,
        "blocked_account_balance": 8928,
        "career_progress": 0,
        "cash_shortfall_count": 9,
        "current_week_work_hours": 0,
        "energy": 4,
        "exam_readiness": 100,
        "failed_courses": 0,
        "flags": {
          "arrears": true,
          "arrived_supplied": true,
          "cash_shortfall": true,
          "cashflow_crisis": true,
          "cashflow_warning": true,
          "housing_contract_active": true,
          "housing_stable": true,
          "no_close_friends": true,
          "registration_delayed": true,
          "shallow_friendships": true,
          "work_law_briefed": true
        },
        "gpa_score": 61,
        "hunger": 100,
        "language": 100,
        "loneliness": 53,
        "money": 0,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 37,
        "stress": 100,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 20,
        "visa_progress": 50,
        "week": 11,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "week": 11
    },
    {
      "anomalies": [
        {
          "evidence": {
            "delta": 33.0,
            "from": 49.0,
            "metric": "stress",
            "replay": {
              "actions": [
                "problem_set",
                "library_day",
                "language_tandem",
                "write_email_practice"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "missing_school_registration",
              "max_weeks": 12,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 3
            },
            "to": 82.0
          },
          "kind": "single_week_spike",
          "message": "`stress` jumped from 49.0 to 82 in a single week (Δ=+33.0).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 3
        },
        {
          "evidence": {
            "delta": 34.0,
            "from": 39.0,
            "metric": "hunger",
            "replay": {
              "actions": [
                "problem_set",
                "library_day",
                "language_tandem",
                "write_email_practice"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "missing_school_registration",
              "max_weeks": 12,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 3
            },
            "to": 73.0
          },
          "kind": "single_week_spike",
          "message": "`hunger` jumped from 39.0 to 73 in a single week (Δ=+34.0).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 3
        },
        {
          "evidence": {
            "replay": {
              "actions": [
                "problem_set",
                "library_day",
                "language_tandem",
                "write_email_practice"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "group_invite",
              "max_weeks": 12,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 12
            },
            "streak_weeks": 9,
            "threshold": 85.0
          },
          "kind": "hunger_ignored_too_long",
          "message": "Hunger ≥ 85 for 9 consecutive weeks (week=12).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 12
        }
      ],
      "attractors": [],
      "available_action_ids": [
        "problem_set",
        "library_day",
        "language_tandem",
        "write_email_practice",
        "watch_german_news",
        "visa_appointment",
        "international_office",
        "emergency_international_office",
        "write_formal_email_to_abh",
        "part_time_job",
        "mini_job_extra",
        "scholarship",
        "budget_call",
        "sell_unused_stuff",
        "rent_talk_extension",
        "sleep_recover",
        "go_running",
        "take_a_real_break",
        "bilibili_rest",
        "cv_workshop",
        "apply_howi"
      ],
      "decision": {
        "confidence": 1.0,
        "expected_tradeoff": "deterministic fixture authoring choice",
        "risk_awareness": [
          "registration_delayed",
          "hunger",
          "stress"
        ],
        "strategic_goal": "exercise money priorities"
      },
      "delta": {
        "loneliness": 3,
        "social": 1,
        "visa_progress": 2
      },
      "event": {
        "id": "group_invite",
        "legal_choices": [
          {
            "choice_id": "group_invite.choice_01_答应并主动分工",
            "failure_effects": {
              "stress": 5.0
            },
            "next_event_id": "",
            "requirements": {
              "language": 0.002,
              "social": 0.003
            },
            "set_flag": "anna_group",
            "success_effects": {
              "academic_progress": 6.0,
              "exam_readiness": 4.0,
              "language": 3.0,
              "social": 8.0
            },
            "success_rate": 0.9,
            "text": "答应并主动分工"
          },
          {
            "choice_id": "group_invite.choice_02_只接资料整理的部分",
            "failure_effects": {
              "academic_progress": -1.0,
              "social": -1.0,
              "stress": 2.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "anna_group",
            "success_effects": {
              "academic_progress": 4.0,
              "exam_readiness": 2.0,
              "social": 3.0,
              "stress": 2.0
            },
            "success_rate": 1.0,
            "text": "只接资料整理的部分"
          },
          {
            "choice_id": "group_invite.choice_03_请她先解释评分标准",
            "failure_effects": {
              "stress": 6.0
            },
            "next_event_id": "",
            "requirements": {
              "language": 0.003,
              "social": 0.002
            },
            "set_flag": "anna_group",
            "success_effects": {
              "exam_readiness": 6.0,
              "language": 3.0,
              "social": 5.0
            },
            "success_rate": 0.853,
            "text": "请她先解释评分标准"
          },
          {
            "choice_id": "group_invite.choice_04_委婉拒绝",
            "failure_effects": {
              "stress": 4.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "academic_progress": -3.0,
              "social": -4.0,
              "stress": -3.0
            },
            "success_rate": 1.0,
            "text": "委婉拒绝"
          }
        ],
        "selected_choice_id": "group_invite.choice_01_答应并主动分工"
      },
      "evidence": {
        "decision_request_fingerprint": "07ff6da58a3b529bef7646a63a267d9ff5572b9bac5c63492c8f26dc55ac91a6",
        "event_request_fingerprint": "f4a4cb63c853dc9121683240e7d2199f2c238e7288336e2457a7b8681d98ae92",
        "source_line": 12,
        "source_record_sha256": "96713967f0ca147c0d14ce8a23909d74c059a74f14283b27e69d0a99d6cf890b"
      },
      "finished": false,
      "full_numeric_delta": {
        "arrears_amount": 255,
        "cash_shortfall_count": 1,
        "loneliness": 3,
        "social": 1,
        "unpaid_social_streak": 2,
        "visa_progress": 2,
        "week": 1
      },
      "id": "w12",
      "kind": "actual",
      "risk_guidance": {
        "contract_version": "1.0",
        "evaluator": "RiskEvaluator.get_top_risks",
        "generated_for_week": 13,
        "source": "game_risk_evaluator",
        "top_risks": [
          {
            "body": "压力 100。高压会拖累学业和考试，并可能覆盖普通成功结局。",
            "id": "stress",
            "score": 100,
            "suggested_actions": [
              "take_a_real_break",
              "therapy",
              "sleep_recover",
              "go_running"
            ],
            "title": "压力"
          },
          {
            "body": "饥饿 100。吃饭问题会持续扣精力、加压力、拖学业。",
            "id": "hunger",
            "score": 100,
            "suggested_actions": [
              "cook_at_home",
              "cheap_noodle_week",
              "mensa_coupon",
              "classmate_meal",
              "wg_dinner"
            ],
            "title": "饥饿/生活"
          },
          {
            "body": "当前可支配现金 0 EUR，逾期 2829 EUR。逾期会推高压力和饥饿，并诱发黑工选择。",
            "id": "money",
            "score": 96,
            "suggested_actions": [
              "rent_talk_extension",
              "budget_call",
              "part_time_job",
              "sell_unused_stuff",
              "cook_at_home"
            ],
            "title": "现金流"
          }
        ]
      },
      "selected_action_ids": [
        "problem_set",
        "library_day",
        "language_tandem",
        "write_email_practice"
      ],
      "state_after": {
        "academic_progress": 93,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 2829,
        "blocked_account_balance": 8928,
        "career_progress": 0,
        "cash_shortfall_count": 11,
        "current_week_work_hours": 0,
        "energy": 16,
        "exam_readiness": 100,
        "failed_courses": 0,
        "flags": {
          "arrears": true,
          "arrived_supplied": true,
          "cash_shortfall": true,
          "cashflow_crisis": true,
          "cashflow_warning": true,
          "housing_contract_active": true,
          "housing_stable": true,
          "no_close_friends": true,
          "registration_delayed": true,
          "shallow_friendships": true,
          "work_law_briefed": true
        },
        "gpa_score": 61,
        "hunger": 100,
        "language": 100,
        "loneliness": 59,
        "money": 0,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 39,
        "stress": 100,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 24,
        "visa_progress": 54,
        "week": 13,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "state_before": {
        "academic_progress": 93,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 2574,
        "blocked_account_balance": 8928,
        "career_progress": 0,
        "cash_shortfall_count": 10,
        "current_week_work_hours": 0,
        "energy": 16,
        "exam_readiness": 100,
        "failed_courses": 0,
        "flags": {
          "arrears": true,
          "arrived_supplied": true,
          "cash_shortfall": true,
          "cashflow_crisis": true,
          "cashflow_warning": true,
          "housing_contract_active": true,
          "housing_stable": true,
          "no_close_friends": true,
          "registration_delayed": true,
          "shallow_friendships": true,
          "work_law_briefed": true
        },
        "gpa_score": 61,
        "hunger": 100,
        "language": 100,
        "loneliness": 56,
        "money": 0,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 38,
        "stress": 100,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 22,
        "visa_progress": 52,
        "week": 12,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "week": 12
    },
    {
      "anomalies": [
        {
          "evidence": {
            "delta": 33.0,
            "from": 49.0,
            "metric": "stress",
            "replay": {
              "actions": [
                "problem_set",
                "library_day",
                "language_tandem",
                "write_email_practice"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "missing_school_registration",
              "max_weeks": 13,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 3
            },
            "to": 82.0
          },
          "kind": "single_week_spike",
          "message": "`stress` jumped from 49.0 to 82 in a single week (Δ=+33.0).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 3
        },
        {
          "evidence": {
            "delta": 34.0,
            "from": 39.0,
            "metric": "hunger",
            "replay": {
              "actions": [
                "problem_set",
                "library_day",
                "language_tandem",
                "write_email_practice"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "missing_school_registration",
              "max_weeks": 13,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 3
            },
            "to": 73.0
          },
          "kind": "single_week_spike",
          "message": "`hunger` jumped from 39.0 to 73 in a single week (Δ=+34.0).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 3
        },
        {
          "evidence": {
            "replay": {
              "actions": [
                "problem_set",
                "library_day",
                "language_tandem",
                "write_email_practice"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "exercise_sheet_warning",
              "max_weeks": 13,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 13
            },
            "streak_weeks": 10,
            "threshold": 85.0
          },
          "kind": "hunger_ignored_too_long",
          "message": "Hunger ≥ 85 for 10 consecutive weeks (week=13).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 13
        }
      ],
      "attractors": [],
      "available_action_ids": [
        "problem_set",
        "library_day",
        "language_tandem",
        "write_email_practice",
        "watch_german_news",
        "visa_appointment",
        "international_office",
        "emergency_international_office",
        "write_formal_email_to_abh",
        "part_time_job",
        "mini_job_extra",
        "scholarship",
        "budget_call",
        "sell_unused_stuff",
        "rent_talk_extension",
        "sleep_recover",
        "go_running",
        "take_a_real_break",
        "bilibili_rest",
        "cv_workshop",
        "apply_howi"
      ],
      "decision": {
        "confidence": 1.0,
        "expected_tradeoff": "deterministic fixture authoring choice",
        "risk_awareness": [
          "registration_delayed",
          "hunger",
          "stress"
        ],
        "strategic_goal": "exercise money priorities"
      },
      "delta": {
        "academic_progress": -3,
        "exam_readiness": -8,
        "loneliness": 3,
        "money": 117,
        "social": 1,
        "stress": -2,
        "visa_progress": 2
      },
      "event": {
        "id": "exercise_sheet_warning",
        "legal_choices": [
          {
            "choice_id": "exercise_sheet_warning.choice_01_补三套练习题",
            "failure_effects": {
              "exam_readiness": 2.0,
              "stress": 10.0
            },
            "next_event_id": "",
            "requirements": {
              "academic_progress": 0.003
            },
            "set_flag": "",
            "success_effects": {
              "academic_progress": 3.0,
              "exam_readiness": 10.0,
              "stress": 6.0
            },
            "success_rate": 0.775,
            "text": "补三套练习题"
          },
          {
            "choice_id": "exercise_sheet_warning.choice_02_去_tutorium_问清楚",
            "failure_effects": {
              "stress": 7.0
            },
            "next_event_id": "",
            "requirements": {
              "language": 0.003
            },
            "set_flag": "",
            "success_effects": {
              "exam_readiness": 7.0,
              "language": 2.0,
              "stress": 3.0
            },
            "success_rate": 0.756,
            "text": "去 Tutorium 问清楚"
          },
          {
            "choice_id": "exercise_sheet_warning.choice_03_和同学对答案",
            "failure_effects": {
              "exam_readiness": -2.0,
              "stress": 6.0
            },
            "next_event_id": "",
            "requirements": {
              "social": 0.003
            },
            "set_flag": "",
            "success_effects": {
              "exam_readiness": 6.0,
              "social": 4.0,
              "stress": 2.0
            },
            "success_rate": 0.516,
            "text": "和同学对答案"
          },
          {
            "choice_id": "exercise_sheet_warning.choice_04_先忙别的",
            "failure_effects": {
              "stress": 4.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "academic_progress": -3.0,
              "exam_readiness": -8.0,
              "stress": -2.0
            },
            "success_rate": 1.0,
            "text": "先忙别的"
          }
        ],
        "selected_choice_id": "exercise_sheet_warning.choice_04_先忙别的"
      },
      "evidence": {
        "decision_request_fingerprint": "c759fc4a91129d846266d3e489a1469c180f95414636fc1b5514f9e04dde6093",
        "event_request_fingerprint": "65e8ecfc75939d3b5048e774d73f98cd16acc7a1c379340d7e2ade2f1f16f99e",
        "source_line": 13,
        "source_record_sha256": "2979691f88128f431021d3160679f37e668a833c2afc8df7acfb3979a7edc7d9"
      },
      "finished": false,
      "full_numeric_delta": {
        "academic_progress": -3,
        "blocked_account_balance": -992,
        "exam_readiness": -8,
        "loneliness": 3,
        "money": 117,
        "social": 1,
        "stress": -2,
        "unpaid_social_streak": 2,
        "visa_progress": 2,
        "week": 1
      },
      "id": "w13",
      "kind": "actual",
      "risk_guidance": {
        "contract_version": "1.0",
        "evaluator": "RiskEvaluator.get_top_risks",
        "generated_for_week": 14,
        "source": "game_risk_evaluator",
        "top_risks": [
          {
            "body": "饥饿 100。吃饭问题会持续扣精力、加压力、拖学业。",
            "id": "hunger",
            "score": 100,
            "suggested_actions": [
              "cook_at_home",
              "cheap_noodle_week",
              "mensa_coupon",
              "classmate_meal",
              "wg_dinner"
            ],
            "title": "饥饿/生活"
          },
          {
            "body": "压力 98。高压会拖累学业和考试，并可能覆盖普通成功结局。",
            "id": "stress",
            "score": 98,
            "suggested_actions": [
              "take_a_real_break",
              "therapy",
              "sleep_recover",
              "go_running"
            ],
            "title": "压力"
          },
          {
            "body": "当前可支配现金 117 EUR，逾期 2829 EUR。逾期会推高压力和饥饿，并诱发黑工选择。",
            "id": "money",
            "score": 96,
            "suggested_actions": [
              "rent_talk_extension",
              "budget_call",
              "part_time_job",
              "sell_unused_stuff",
              "cook_at_home"
            ],
            "title": "现金流"
          }
        ]
      },
      "selected_action_ids": [
        "problem_set",
        "library_day",
        "language_tandem",
        "write_email_practice"
      ],
      "state_after": {
        "academic_progress": 90,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 2829,
        "blocked_account_balance": 7936,
        "career_progress": 0,
        "cash_shortfall_count": 11,
        "current_week_work_hours": 0,
        "energy": 16,
        "exam_readiness": 92,
        "failed_courses": 0,
        "flags": {
          "arrears": true,
          "arrived_supplied": true,
          "cash_shortfall": true,
          "cashflow_crisis": true,
          "cashflow_warning": true,
          "housing_contract_active": true,
          "housing_stable": true,
          "no_close_friends": true,
          "registration_delayed": true,
          "shallow_friendships": true,
          "work_law_briefed": true
        },
        "gpa_score": 61,
        "hunger": 100,
        "language": 100,
        "loneliness": 62,
        "money": 117,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 40,
        "stress": 98,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 26,
        "visa_progress": 56,
        "week": 14,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "state_before": {
        "academic_progress": 93,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 2829,
        "blocked_account_balance": 8928,
        "career_progress": 0,
        "cash_shortfall_count": 11,
        "current_week_work_hours": 0,
        "energy": 16,
        "exam_readiness": 100,
        "failed_courses": 0,
        "flags": {
          "arrears": true,
          "arrived_supplied": true,
          "cash_shortfall": true,
          "cashflow_crisis": true,
          "cashflow_warning": true,
          "housing_contract_active": true,
          "housing_stable": true,
          "no_close_friends": true,
          "registration_delayed": true,
          "shallow_friendships": true,
          "work_law_briefed": true
        },
        "gpa_score": 61,
        "hunger": 100,
        "language": 100,
        "loneliness": 59,
        "money": 0,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 39,
        "stress": 100,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 24,
        "visa_progress": 54,
        "week": 13,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "week": 13
    },
    {
      "anomalies": [
        {
          "evidence": {
            "delta": 33.0,
            "from": 49.0,
            "metric": "stress",
            "replay": {
              "actions": [
                "problem_set",
                "library_day",
                "language_tandem",
                "write_email_practice"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "missing_school_registration",
              "max_weeks": 14,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 3
            },
            "to": 82.0
          },
          "kind": "single_week_spike",
          "message": "`stress` jumped from 49.0 to 82 in a single week (Δ=+33.0).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 3
        },
        {
          "evidence": {
            "delta": 34.0,
            "from": 39.0,
            "metric": "hunger",
            "replay": {
              "actions": [
                "problem_set",
                "library_day",
                "language_tandem",
                "write_email_practice"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "missing_school_registration",
              "max_weeks": 14,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 3
            },
            "to": 73.0
          },
          "kind": "single_week_spike",
          "message": "`hunger` jumped from 39.0 to 73 in a single week (Δ=+34.0).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 3
        },
        {
          "evidence": {
            "replay": {
              "actions": [
                "problem_set",
                "library_day",
                "language_tandem",
                "write_email_practice"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "visa_status_hidden_check",
              "max_weeks": 14,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 14
            },
            "streak_weeks": 11,
            "threshold": 85.0
          },
          "kind": "hunger_ignored_too_long",
          "message": "Hunger ≥ 85 for 11 consecutive weeks (week=14).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 14
        }
      ],
      "attractors": [],
      "available_action_ids": [
        "problem_set",
        "library_day",
        "language_tandem",
        "write_email_practice",
        "watch_german_news",
        "visa_appointment",
        "international_office",
        "emergency_international_office",
        "write_formal_email_to_abh",
        "part_time_job",
        "mini_job_extra",
        "scholarship",
        "budget_call",
        "sell_unused_stuff",
        "rent_talk_extension",
        "cook_at_home",
        "cheap_noodle_week",
        "mensa_coupon",
        "wg_dinner",
        "student_club",
        "classmate_meal",
        "date_night",
        "sleep_recover",
        "go_running",
        "take_a_real_break",
        "bilibili_rest",
        "cv_workshop",
        "apply_howi"
      ],
      "decision": {
        "confidence": 1.0,
        "expected_tradeoff": "deterministic fixture authoring choice",
        "risk_awareness": [
          "registration_delayed",
          "hunger",
          "stress"
        ],
        "strategic_goal": "exercise money priorities"
      },
      "delta": {
        "academic_progress": 3,
        "exam_readiness": 8,
        "loneliness": 3,
        "money": -117,
        "social": 1,
        "stress": 2,
        "visa_progress": 11
      },
      "event": {
        "id": "visa_status_hidden_check",
        "legal_choices": [
          {
            "choice_id": "visa_status_hidden_check.choice_01_立刻联系外管局和学校",
            "failure_effects": {
              "stress": 14.0,
              "visa_progress": -3.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "visa_valid",
            "success_effects": {
              "language": 2.0,
              "stress": 9.0,
              "visa_progress": 9.0
            },
            "success_rate": 0.756,
            "text": "立刻联系外管局和学校"
          },
          {
            "choice_id": "visa_status_hidden_check.choice_02_补材料并申请_fiktionsbescheinigung",
            "failure_effects": {
              "stress": 12.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "visa_valid",
            "success_effects": {
              "stress": 7.0,
              "visa_progress": 7.0
            },
            "success_rate": 0.676,
            "text": "补材料并申请 Fiktionsbescheinigung"
          },
          {
            "choice_id": "visa_status_hidden_check.choice_03_只在网页上继续刷_termin",
            "failure_effects": {
              "stress": 16.0,
              "visa_progress": -4.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "deportation_warning",
            "success_effects": {
              "stress": 10.0,
              "visa_progress": 3.0
            },
            "success_rate": 0.436,
            "text": "只在网页上继续刷 Termin"
          },
          {
            "choice_id": "visa_status_hidden_check.choice_04_相信不会查到自己",
            "failure_effects": {
              "stress": 8.0,
              "visa_progress": -12.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "deportation_warning",
            "success_effects": {
              "stress": -2.0,
              "visa_progress": -8.0
            },
            "success_rate": 0.366,
            "text": "相信不会查到自己"
          }
        ],
        "selected_choice_id": "visa_status_hidden_check.choice_01_立刻联系外管局和学校"
      },
      "evidence": {
        "decision_request_fingerprint": "c2c1bfabc8203533bf1cf6b3f012562909a2380afbb23226dad2fbf1ce1ff957",
        "event_request_fingerprint": "ee76664ce2fae28b9e3f8eaac626524dc43eecdf2dcfd65d893e6e303e56664e",
        "source_line": 14,
        "source_record_sha256": "bd91c385b342d316628880aa3749a4c6a7cdaf30ddbf151a20df753067c77bf2"
      },
      "finished": false,
      "full_numeric_delta": {
        "academic_progress": 3,
        "arrears_amount": 138,
        "cash_shortfall_count": 1,
        "exam_readiness": 8,
        "loneliness": 3,
        "money": -117,
        "social": 1,
        "stress": 2,
        "unpaid_social_streak": 2,
        "visa_progress": 11,
        "week": 1
      },
      "id": "w14",
      "kind": "actual",
      "risk_guidance": {
        "contract_version": "1.0",
        "evaluator": "RiskEvaluator.get_top_risks",
        "generated_for_week": 15,
        "source": "game_risk_evaluator",
        "top_risks": [
          {
            "body": "压力 100。高压会拖累学业和考试，并可能覆盖普通成功结局。",
            "id": "stress",
            "score": 100,
            "suggested_actions": [
              "take_a_real_break",
              "therapy",
              "sleep_recover",
              "go_running"
            ],
            "title": "压力"
          },
          {
            "body": "饥饿 100。吃饭问题会持续扣精力、加压力、拖学业。",
            "id": "hunger",
            "score": 100,
            "suggested_actions": [
              "cook_at_home",
              "cheap_noodle_week",
              "mensa_coupon",
              "classmate_meal",
              "wg_dinner"
            ],
            "title": "饥饿/生活"
          },
          {
            "body": "当前可支配现金 0 EUR，逾期 2967 EUR。逾期会推高压力和饥饿，并诱发黑工选择。",
            "id": "money",
            "score": 96,
            "suggested_actions": [
              "rent_talk_extension",
              "budget_call",
              "part_time_job",
              "sell_unused_stuff",
              "cook_at_home"
            ],
            "title": "现金流"
          }
        ]
      },
      "selected_action_ids": [
        "problem_set",
        "library_day",
        "language_tandem",
        "write_email_practice"
      ],
      "state_after": {
        "academic_progress": 93,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 2967,
        "blocked_account_balance": 7936,
        "career_progress": 0,
        "cash_shortfall_count": 12,
        "current_week_work_hours": 0,
        "energy": 16,
        "exam_readiness": 100,
        "failed_courses": 0,
        "flags": {
          "arrears": true,
          "arrived_supplied": true,
          "cash_shortfall": true,
          "cashflow_crisis": true,
          "cashflow_warning": true,
          "housing_contract_active": true,
          "housing_stable": true,
          "no_close_friends": true,
          "registration_delayed": true,
          "shallow_friendships": true,
          "visa_valid": true,
          "work_law_briefed": true
        },
        "gpa_score": 61,
        "hunger": 100,
        "language": 100,
        "loneliness": 65,
        "money": 0,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 41,
        "stress": 100,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 28,
        "visa_progress": 67,
        "week": 15,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "state_before": {
        "academic_progress": 90,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 2829,
        "blocked_account_balance": 7936,
        "career_progress": 0,
        "cash_shortfall_count": 11,
        "current_week_work_hours": 0,
        "energy": 16,
        "exam_readiness": 92,
        "failed_courses": 0,
        "flags": {
          "arrears": true,
          "arrived_supplied": true,
          "cash_shortfall": true,
          "cashflow_crisis": true,
          "cashflow_warning": true,
          "housing_contract_active": true,
          "housing_stable": true,
          "no_close_friends": true,
          "registration_delayed": true,
          "shallow_friendships": true,
          "work_law_briefed": true
        },
        "gpa_score": 61,
        "hunger": 100,
        "language": 100,
        "loneliness": 62,
        "money": 117,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 40,
        "stress": 98,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 26,
        "visa_progress": 56,
        "week": 14,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "week": 14
    },
    {
      "anomalies": [
        {
          "evidence": {
            "delta": 33.0,
            "from": 49.0,
            "metric": "stress",
            "replay": {
              "actions": [
                "problem_set",
                "library_day",
                "language_tandem",
                "write_email_practice"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "missing_school_registration",
              "max_weeks": 15,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 3
            },
            "to": 82.0
          },
          "kind": "single_week_spike",
          "message": "`stress` jumped from 49.0 to 82 in a single week (Δ=+33.0).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 3
        },
        {
          "evidence": {
            "delta": 34.0,
            "from": 39.0,
            "metric": "hunger",
            "replay": {
              "actions": [
                "problem_set",
                "library_day",
                "language_tandem",
                "write_email_practice"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "missing_school_registration",
              "max_weeks": 15,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 3
            },
            "to": 73.0
          },
          "kind": "single_week_spike",
          "message": "`hunger` jumped from 39.0 to 73 in a single week (Δ=+34.0).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 3
        },
        {
          "evidence": {
            "replay": {
              "actions": [
                "problem_set",
                "library_day",
                "language_tandem",
                "write_email_practice"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "visa_status_hidden_check",
              "max_weeks": 15,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 14
            },
            "streak_weeks": 0,
            "threshold": 85.0
          },
          "kind": "hunger_ignored_too_long",
          "message": "Hunger ≥ 85 for 0 consecutive weeks (week=14).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 14
        }
      ],
      "attractors": [],
      "available_action_ids": [
        "problem_set",
        "library_day",
        "language_tandem",
        "write_email_practice",
        "watch_german_news",
        "international_office",
        "emergency_international_office",
        "write_formal_email_to_abh",
        "part_time_job",
        "mini_job_extra",
        "scholarship",
        "budget_call",
        "sell_unused_stuff",
        "rent_talk_extension",
        "sleep_recover",
        "go_running",
        "take_a_real_break",
        "bilibili_rest",
        "cv_workshop",
        "apply_howi"
      ],
      "decision": {
        "confidence": 1.0,
        "expected_tradeoff": "deterministic fixture authoring choice",
        "risk_awareness": [
          "registration_delayed",
          "hunger",
          "stress"
        ],
        "strategic_goal": "exercise money priorities"
      },
      "delta": {
        "academic_progress": -9,
        "energy": -16,
        "hunger": -18,
        "loneliness": 3,
        "money": 400,
        "social": 1,
        "visa_progress": 2
      },
      "event": {
        "id": "desperate_illegal_work_offer",
        "legal_choices": [
          {
            "choice_id": "desperate_illegal_work_offer.choice_01_找学生会紧急援助",
            "failure_effects": {
              "hunger": -8.0,
              "stress": 12.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "hunger": -18.0,
              "money": 120.0,
              "social": 2.0,
              "stress": 6.0
            },
            "success_rate": 0.478,
            "text": "找学生会紧急援助"
          },
          {
            "choice_id": "desperate_illegal_work_offer.choice_03_向同学或父母借钱",
            "failure_effects": {
              "loneliness": 5.0,
              "stress": 16.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "hunger": -12.0,
              "loneliness": -3.0,
              "money": 260.0,
              "stress": 9.0
            },
            "success_rate": 0.464,
            "text": "向同学或父母借钱"
          },
          {
            "choice_id": "desperate_illegal_work_offer.choice_04_接下现金黑工",
            "failure_effects": {
              "energy": -25.0,
              "illegal_work_hours": 14.0,
              "stress": 24.0,
              "visa_progress": -8.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "illegal_work_taken",
            "success_effects": {
              "academic_progress": -9.0,
              "energy": -34.0,
              "hunger": -18.0,
              "illegal_work_hours": 36.0,
              "stress": 20.0
            },
            "success_rate": 0.591,
            "text": "接下现金黑工"
          },
          {
            "choice_id": "desperate_illegal_work_offer.choice_05_去食物救助/低价食堂",
            "failure_effects": {
              "hunger": -18.0,
              "stress": 12.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "hunger": -34.0,
              "money": 20.0,
              "social": -1.0,
              "stress": 8.0
            },
            "success_rate": 0.638,
            "text": "去食物救助/低价食堂"
          }
        ],
        "selected_choice_id": "desperate_illegal_work_offer.choice_04_接下现金黑工"
      },
      "evidence": {
        "decision_request_fingerprint": "e5a7f80f7a1b123564949a8b360191147ee241bdc5a87514277e63b2080b3d38",
        "event_request_fingerprint": "b096d49b6da13dfae119607e038eca51cf88f05ce0607f7b096813e4fb545a11",
        "source_line": 15,
        "source_record_sha256": "5d1c0db8a323b9567049a2f68919dfee8154a674177ceb0a657dbdc2ff9f8d03"
      },
      "finished": false,
      "full_numeric_delta": {
        "academic_progress": -9,
        "arrears_amount": 255,
        "cash_shortfall_count": 1,
        "energy": -16,
        "hunger": -18,
        "loneliness": 3,
        "money": 400,
        "social": 1,
        "unpaid_social_streak": 2,
        "visa_progress": 2,
        "week": 1
      },
      "id": "w15",
      "kind": "actual",
      "risk_guidance": {
        "contract_version": "1.0",
        "evaluator": "RiskEvaluator.get_top_risks",
        "generated_for_week": 16,
        "source": "game_risk_evaluator",
        "top_risks": [
          {
            "body": "压力 100。高压会拖累学业和考试，并可能覆盖普通成功结局。",
            "id": "stress",
            "score": 100,
            "suggested_actions": [
              "take_a_real_break",
              "therapy",
              "sleep_recover",
              "go_running"
            ],
            "title": "压力"
          },
          {
            "body": "当前可支配现金 400 EUR，逾期 3222 EUR。逾期会推高压力和饥饿，并诱发黑工选择。",
            "id": "money",
            "score": 96,
            "suggested_actions": [
              "rent_talk_extension",
              "budget_call",
              "part_time_job",
              "sell_unused_stuff",
              "cook_at_home"
            ],
            "title": "现金流"
          },
          {
            "body": "正常注册窗口已错过，只能准备下学期注册并控制生活成本。",
            "id": "registration_delayed",
            "score": 82,
            "suggested_actions": [
              "next_semester_registration",
              "international_office"
            ],
            "title": "注册已延期"
          }
        ]
      },
      "selected_action_ids": [
        "problem_set",
        "library_day",
        "language_tandem",
        "write_email_practice"
      ],
      "state_after": {
        "academic_progress": 84,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 3222,
        "blocked_account_balance": 7936,
        "career_progress": 0,
        "cash_shortfall_count": 13,
        "current_week_work_hours": 0,
        "energy": 0,
        "exam_readiness": 100,
        "failed_courses": 0,
        "flags": {
          "arrears": true,
          "arrived_supplied": true,
          "cash_shortfall": true,
          "cashflow_crisis": true,
          "cashflow_warning": true,
          "housing_contract_active": true,
          "housing_stable": true,
          "illegal_work_taken": true,
          "no_close_friends": true,
          "registration_delayed": true,
          "shallow_friendships": true,
          "visa_valid": true,
          "work_law_briefed": true
        },
        "gpa_score": 61,
        "hunger": 82,
        "language": 100,
        "loneliness": 68,
        "money": 400,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 42,
        "stress": 100,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 30,
        "visa_progress": 69,
        "week": 16,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "state_before": {
        "academic_progress": 93,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 2967,
        "blocked_account_balance": 7936,
        "career_progress": 0,
        "cash_shortfall_count": 12,
        "current_week_work_hours": 0,
        "energy": 16,
        "exam_readiness": 100,
        "failed_courses": 0,
        "flags": {
          "arrears": true,
          "arrived_supplied": true,
          "cash_shortfall": true,
          "cashflow_crisis": true,
          "cashflow_warning": true,
          "housing_contract_active": true,
          "housing_stable": true,
          "no_close_friends": true,
          "registration_delayed": true,
          "shallow_friendships": true,
          "visa_valid": true,
          "work_law_briefed": true
        },
        "gpa_score": 61,
        "hunger": 100,
        "language": 100,
        "loneliness": 65,
        "money": 0,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 41,
        "stress": 100,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 28,
        "visa_progress": 67,
        "week": 15,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "week": 15
    },
    {
      "anomalies": [
        {
          "evidence": {
            "delta": 33.0,
            "from": 49.0,
            "metric": "stress",
            "replay": {
              "actions": [
                "problem_set",
                "library_day",
                "language_tandem",
                "write_email_practice"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "missing_school_registration",
              "max_weeks": 16,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 3
            },
            "to": 82.0
          },
          "kind": "single_week_spike",
          "message": "`stress` jumped from 49.0 to 82 in a single week (Δ=+33.0).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 3
        },
        {
          "evidence": {
            "delta": 34.0,
            "from": 39.0,
            "metric": "hunger",
            "replay": {
              "actions": [
                "problem_set",
                "library_day",
                "language_tandem",
                "write_email_practice"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "missing_school_registration",
              "max_weeks": 16,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 3
            },
            "to": 73.0
          },
          "kind": "single_week_spike",
          "message": "`hunger` jumped from 39.0 to 73 in a single week (Δ=+34.0).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 3
        },
        {
          "evidence": {
            "replay": {
              "actions": [
                "problem_set",
                "library_day",
                "language_tandem",
                "write_email_practice"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "visa_status_hidden_check",
              "max_weeks": 16,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 14
            },
            "streak_weeks": 1,
            "threshold": 85.0
          },
          "kind": "hunger_ignored_too_long",
          "message": "Hunger ≥ 85 for 1 consecutive weeks (week=14).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 14
        }
      ],
      "attractors": [],
      "available_action_ids": [
        "problem_set",
        "library_day",
        "testdaf_exam_germany",
        "language_tandem",
        "write_email_practice",
        "watch_german_news",
        "international_office",
        "emergency_international_office",
        "write_formal_email_to_abh",
        "part_time_job",
        "mini_job_extra",
        "scholarship",
        "budget_call",
        "sell_unused_stuff",
        "rent_talk_extension",
        "cook_at_home",
        "cheap_noodle_week",
        "mensa_coupon",
        "wg_dinner",
        "student_club",
        "classmate_meal",
        "date_night",
        "sleep_recover",
        "go_running",
        "take_a_real_break",
        "therapy",
        "bilibili_rest",
        "cv_workshop",
        "apply_howi"
      ],
      "decision": {
        "confidence": 1.0,
        "expected_tradeoff": "deterministic fixture authoring choice",
        "risk_awareness": [
          "registration_delayed",
          "hunger",
          "stress"
        ],
        "strategic_goal": "exercise money priorities"
      },
      "delta": {
        "academic_progress": 10,
        "energy": 16,
        "hunger": 18,
        "loneliness": 3,
        "money": -400,
        "social": 1
      },
      "event": {
        "id": "klausur_countdown",
        "legal_choices": [
          {
            "choice_id": "klausur_countdown.choice_01_整理错题清单",
            "failure_effects": {
              "exam_readiness": 2.0,
              "stress": 9.0
            },
            "next_event_id": "",
            "requirements": {
              "exam_readiness": 0.004
            },
            "set_flag": "",
            "success_effects": {
              "exam_readiness": 12.0,
              "stress": 5.0
            },
            "success_rate": 0.466,
            "text": "整理错题清单"
          },
          {
            "choice_id": "klausur_countdown.choice_02_约教授/助教答疑",
            "failure_effects": {
              "stress": 9.0
            },
            "next_event_id": "",
            "requirements": {
              "academic_progress": 0.003,
              "language": 0.003
            },
            "set_flag": "",
            "success_effects": {
              "academic_progress": 3.0,
              "exam_readiness": 8.0,
              "stress": 3.0
            },
            "success_rate": 0.658,
            "text": "约教授/助教答疑"
          },
          {
            "choice_id": "klausur_countdown.choice_03_和小组模拟考试",
            "failure_effects": {
              "exam_readiness": 1.0,
              "stress": 8.0
            },
            "next_event_id": "",
            "requirements": {
              "social": 0.003
            },
            "set_flag": "",
            "success_effects": {
              "exam_readiness": 9.0,
              "social": 4.0,
              "stress": 4.0
            },
            "success_rate": 0.545,
            "text": "和小组模拟考试"
          },
          {
            "choice_id": "klausur_countdown.choice_04_继续拖延",
            "failure_effects": {
              "energy": -4.0,
              "stress": 4.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "energy": 5.0,
              "exam_readiness": -12.0,
              "stress": -4.0
            },
            "success_rate": 1.0,
            "text": "继续拖延"
          }
        ],
        "selected_choice_id": "klausur_countdown.choice_01_整理错题清单"
      },
      "evidence": {
        "decision_request_fingerprint": "ec654164dec73327eac56b3edd9fc1ccdf4102418c2764c8d82c9957ebd9afe6",
        "event_request_fingerprint": "15277b6c7d418a704fd162b4a172f0252848cd2171f770b0eb775147c5bf60ce",
        "source_line": 16,
        "source_record_sha256": "c15fb914809943cd4b9361cb6a242e297e4fb551cfe315c17e02474554e95232"
      },
      "finished": false,
      "full_numeric_delta": {
        "academic_progress": 10,
        "arrears_amount": 215,
        "cash_shortfall_count": 1,
        "energy": 16,
        "hunger": 18,
        "loneliness": 3,
        "money": -400,
        "social": 1,
        "testdaf_listening": 3,
        "testdaf_reading": 3,
        "testdaf_speaking": 3,
        "testdaf_writing": 3,
        "unpaid_social_streak": 2,
        "week": 1
      },
      "id": "w16",
      "kind": "actual",
      "risk_guidance": {
        "contract_version": "1.0",
        "evaluator": "RiskEvaluator.get_top_risks",
        "generated_for_week": 17,
        "source": "game_risk_evaluator",
        "top_risks": [
          {
            "body": "压力 100。高压会拖累学业和考试，并可能覆盖普通成功结局。",
            "id": "stress",
            "score": 100,
            "suggested_actions": [
              "take_a_real_break",
              "therapy",
              "sleep_recover",
              "go_running"
            ],
            "title": "压力"
          },
          {
            "body": "饥饿 100。吃饭问题会持续扣精力、加压力、拖学业。",
            "id": "hunger",
            "score": 100,
            "suggested_actions": [
              "cook_at_home",
              "cheap_noodle_week",
              "mensa_coupon",
              "classmate_meal",
              "wg_dinner"
            ],
            "title": "饥饿/生活"
          },
          {
            "body": "当前可支配现金 0 EUR，逾期 3437 EUR。逾期会推高压力和饥饿，并诱发黑工选择。",
            "id": "money",
            "score": 96,
            "suggested_actions": [
              "rent_talk_extension",
              "budget_call",
              "part_time_job",
              "sell_unused_stuff",
              "cook_at_home"
            ],
            "title": "现金流"
          }
        ]
      },
      "selected_action_ids": [
        "problem_set",
        "library_day",
        "testdaf_exam_germany",
        "language_tandem"
      ],
      "state_after": {
        "academic_progress": 94,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 3437,
        "blocked_account_balance": 7936,
        "career_progress": 0,
        "cash_shortfall_count": 14,
        "current_week_work_hours": 0,
        "energy": 16,
        "exam_readiness": 100,
        "failed_courses": 0,
        "flags": {
          "arrears": true,
          "arrived_supplied": true,
          "cash_shortfall": true,
          "cashflow_crisis": true,
          "cashflow_warning": true,
          "housing_contract_active": true,
          "housing_stable": true,
          "illegal_work_taken": true,
          "no_close_friends": true,
          "registration_delayed": true,
          "shallow_friendships": true,
          "testdaf_passed": true,
          "visa_valid": true,
          "work_law_briefed": true
        },
        "gpa_score": 61,
        "hunger": 100,
        "language": 100,
        "loneliness": 71,
        "money": 0,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 43,
        "stress": 100,
        "testdaf_listening": 5,
        "testdaf_reading": 5,
        "testdaf_speaking": 5,
        "testdaf_writing": 5,
        "university_tier": "未定位",
        "unpaid_social_streak": 32,
        "visa_progress": 69,
        "week": 17,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "state_before": {
        "academic_progress": 84,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 3222,
        "blocked_account_balance": 7936,
        "career_progress": 0,
        "cash_shortfall_count": 13,
        "current_week_work_hours": 0,
        "energy": 0,
        "exam_readiness": 100,
        "failed_courses": 0,
        "flags": {
          "arrears": true,
          "arrived_supplied": true,
          "cash_shortfall": true,
          "cashflow_crisis": true,
          "cashflow_warning": true,
          "housing_contract_active": true,
          "housing_stable": true,
          "illegal_work_taken": true,
          "no_close_friends": true,
          "registration_delayed": true,
          "shallow_friendships": true,
          "visa_valid": true,
          "work_law_briefed": true
        },
        "gpa_score": 61,
        "hunger": 82,
        "language": 100,
        "loneliness": 68,
        "money": 400,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 42,
        "stress": 100,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 30,
        "visa_progress": 69,
        "week": 16,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "week": 16
    },
    {
      "anomalies": [
        {
          "evidence": {
            "delta": 33.0,
            "from": 49.0,
            "metric": "stress",
            "replay": {
              "actions": [
                "problem_set",
                "library_day",
                "language_tandem",
                "write_email_practice"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "missing_school_registration",
              "max_weeks": 17,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 3
            },
            "to": 82.0
          },
          "kind": "single_week_spike",
          "message": "`stress` jumped from 49.0 to 82 in a single week (Δ=+33.0).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 3
        },
        {
          "evidence": {
            "delta": 34.0,
            "from": 39.0,
            "metric": "hunger",
            "replay": {
              "actions": [
                "problem_set",
                "library_day",
                "language_tandem",
                "write_email_practice"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "missing_school_registration",
              "max_weeks": 17,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 3
            },
            "to": 73.0
          },
          "kind": "single_week_spike",
          "message": "`hunger` jumped from 39.0 to 73 in a single week (Δ=+34.0).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 3
        },
        {
          "evidence": {
            "delta": -38.0,
            "from": 100.0,
            "metric": "hunger",
            "replay": {
              "actions": [
                "problem_set",
                "library_day",
                "language_tandem",
                "write_email_practice"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "classmate_home_dinner",
              "max_weeks": 17,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 17
            },
            "to": 62.0
          },
          "kind": "single_week_spike",
          "message": "`hunger` jumped from 100.0 to 62 in a single week (Δ=-38.0).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 17
        },
        {
          "evidence": {
            "replay": {
              "actions": [
                "problem_set",
                "library_day",
                "language_tandem",
                "write_email_practice"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "visa_status_hidden_check",
              "max_weeks": 17,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 14
            },
            "streak_weeks": 0,
            "threshold": 85.0
          },
          "kind": "hunger_ignored_too_long",
          "message": "Hunger ≥ 85 for 0 consecutive weeks (week=14).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 14
        }
      ],
      "attractors": [],
      "available_action_ids": [
        "problem_set",
        "library_day",
        "language_tandem",
        "write_email_practice",
        "watch_german_news",
        "international_office",
        "emergency_international_office",
        "write_formal_email_to_abh",
        "part_time_job",
        "mini_job_extra",
        "scholarship",
        "budget_call",
        "sell_unused_stuff",
        "rent_talk_extension",
        "sleep_recover",
        "go_running",
        "take_a_real_break",
        "bilibili_rest",
        "cv_workshop",
        "apply_howi"
      ],
      "decision": {
        "confidence": 1.0,
        "expected_tradeoff": "deterministic fixture authoring choice",
        "risk_awareness": [
          "registration_delayed",
          "hunger",
          "stress"
        ],
        "strategic_goal": "exercise money priorities"
      },
      "delta": {
        "academic_progress": -1,
        "hunger": -38,
        "loneliness": -3,
        "money": 105,
        "social": 8,
        "visa_progress": 2
      },
      "event": {
        "id": "classmate_home_dinner",
        "legal_choices": [
          {
            "choice_id": "classmate_home_dinner.choice_01_带点水果过去",
            "failure_effects": {
              "hunger": -18.0,
              "stress": 4.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "hunger": -38.0,
              "loneliness": -6.0,
              "money": -12.0,
              "social": 7.0
            },
            "success_rate": 0.717342857142857,
            "text": "带点水果过去"
          },
          {
            "choice_id": "classmate_home_dinner.choice_02_空手去但主动洗碗",
            "failure_effects": {
              "hunger": -15.0,
              "social": -1.0,
              "stress": 3.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "hunger": -32.0,
              "social": 5.0,
              "stress": -2.0
            },
            "success_rate": 0.647342857142857,
            "text": "空手去但主动洗碗"
          },
          {
            "choice_id": "classmate_home_dinner.choice_03_拒绝，回宿舍泡面",
            "failure_effects": {
              "hunger": 6.0,
              "money": -35.0,
              "stress": 2.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "hunger": -16.0,
              "loneliness": 3.0,
              "money": 8.0
            },
            "success_rate": 1.0,
            "text": "拒绝，回宿舍泡面"
          },
          {
            "choice_id": "classmate_home_dinner.choice_04_顺便打包明天午饭",
            "failure_effects": {
              "hunger": -20.0,
              "social": -4.0,
              "stress": 5.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "hunger": -42.0,
              "money": 20.0,
              "social": -1.0
            },
            "success_rate": 0.387342857142857,
            "text": "顺便打包明天午饭"
          }
        ],
        "selected_choice_id": "classmate_home_dinner.choice_01_带点水果过去"
      },
      "evidence": {
        "decision_request_fingerprint": "f92402fcf9dcd78e2a5d2c2396a1cedfc3ab29590634e334ea48866eb1366ed3",
        "event_request_fingerprint": "80514e359fe701e59451e17010ebc433cfbc834cecbdf0205e336cac4f765af9",
        "source_line": 17,
        "source_record_sha256": "4ba32ebb204c636037564b618ce2ccc27ea71d0c18ff81dbaaf28f8b97bfb40f"
      },
      "finished": false,
      "full_numeric_delta": {
        "academic_progress": -1,
        "blocked_account_balance": -992,
        "hunger": -38,
        "loneliness": -3,
        "money": 105,
        "social": 8,
        "unpaid_social_streak": 2,
        "visa_progress": 2,
        "week": 1
      },
      "id": "w17",
      "kind": "actual",
      "risk_guidance": {
        "contract_version": "1.0",
        "evaluator": "RiskEvaluator.get_top_risks",
        "generated_for_week": 18,
        "source": "game_risk_evaluator",
        "top_risks": [
          {
            "body": "压力 100。高压会拖累学业和考试，并可能覆盖普通成功结局。",
            "id": "stress",
            "score": 100,
            "suggested_actions": [
              "take_a_real_break",
              "therapy",
              "sleep_recover",
              "go_running"
            ],
            "title": "压力"
          },
          {
            "body": "当前可支配现金 105 EUR，逾期 3437 EUR。逾期会推高压力和饥饿，并诱发黑工选择。",
            "id": "money",
            "score": 96,
            "suggested_actions": [
              "rent_talk_extension",
              "budget_call",
              "part_time_job",
              "sell_unused_stuff",
              "cook_at_home"
            ],
            "title": "现金流"
          },
          {
            "body": "正常注册窗口已错过，只能准备下学期注册并控制生活成本。",
            "id": "registration_delayed",
            "score": 82,
            "suggested_actions": [
              "next_semester_registration",
              "international_office"
            ],
            "title": "注册已延期"
          }
        ]
      },
      "selected_action_ids": [
        "problem_set",
        "library_day",
        "language_tandem",
        "write_email_practice"
      ],
      "state_after": {
        "academic_progress": 93,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 3437,
        "blocked_account_balance": 6944,
        "career_progress": 0,
        "cash_shortfall_count": 14,
        "current_week_work_hours": 0,
        "energy": 16,
        "exam_readiness": 100,
        "failed_courses": 0,
        "flags": {
          "arrears": true,
          "arrived_supplied": true,
          "cash_shortfall": true,
          "cashflow_crisis": true,
          "cashflow_warning": true,
          "housing_contract_active": true,
          "housing_stable": true,
          "illegal_work_taken": true,
          "no_close_friends": true,
          "registration_delayed": true,
          "shallow_friendships": true,
          "testdaf_passed": true,
          "visa_valid": true,
          "work_law_briefed": true
        },
        "gpa_score": 61,
        "hunger": 62,
        "language": 100,
        "loneliness": 68,
        "money": 105,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 51,
        "stress": 100,
        "testdaf_listening": 5,
        "testdaf_reading": 5,
        "testdaf_speaking": 5,
        "testdaf_writing": 5,
        "university_tier": "未定位",
        "unpaid_social_streak": 34,
        "visa_progress": 71,
        "week": 18,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "state_before": {
        "academic_progress": 94,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 3437,
        "blocked_account_balance": 7936,
        "career_progress": 0,
        "cash_shortfall_count": 14,
        "current_week_work_hours": 0,
        "energy": 16,
        "exam_readiness": 100,
        "failed_courses": 0,
        "flags": {
          "arrears": true,
          "arrived_supplied": true,
          "cash_shortfall": true,
          "cashflow_crisis": true,
          "cashflow_warning": true,
          "housing_contract_active": true,
          "housing_stable": true,
          "illegal_work_taken": true,
          "no_close_friends": true,
          "registration_delayed": true,
          "shallow_friendships": true,
          "testdaf_passed": true,
          "visa_valid": true,
          "work_law_briefed": true
        },
        "gpa_score": 61,
        "hunger": 100,
        "language": 100,
        "loneliness": 71,
        "money": 0,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 43,
        "stress": 100,
        "testdaf_listening": 5,
        "testdaf_reading": 5,
        "testdaf_speaking": 5,
        "testdaf_writing": 5,
        "university_tier": "未定位",
        "unpaid_social_streak": 32,
        "visa_progress": 69,
        "week": 17,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "week": 17
    },
    {
      "anomalies": [
        {
          "evidence": {
            "delta": 33.0,
            "from": 49.0,
            "metric": "stress",
            "replay": {
              "actions": [
                "problem_set",
                "library_day",
                "language_tandem",
                "write_email_practice"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "missing_school_registration",
              "max_weeks": 18,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 3
            },
            "to": 82.0
          },
          "kind": "single_week_spike",
          "message": "`stress` jumped from 49.0 to 82 in a single week (Δ=+33.0).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 3
        },
        {
          "evidence": {
            "delta": 34.0,
            "from": 39.0,
            "metric": "hunger",
            "replay": {
              "actions": [
                "problem_set",
                "library_day",
                "language_tandem",
                "write_email_practice"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "missing_school_registration",
              "max_weeks": 18,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 3
            },
            "to": 73.0
          },
          "kind": "single_week_spike",
          "message": "`hunger` jumped from 39.0 to 73 in a single week (Δ=+34.0).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 3
        },
        {
          "evidence": {
            "delta": -38.0,
            "from": 100.0,
            "metric": "hunger",
            "replay": {
              "actions": [
                "problem_set",
                "library_day",
                "language_tandem",
                "write_email_practice"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "classmate_home_dinner",
              "max_weeks": 18,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 17
            },
            "to": 62.0
          },
          "kind": "single_week_spike",
          "message": "`hunger` jumped from 100.0 to 62 in a single week (Δ=-38.0).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 17
        },
        {
          "evidence": {
            "delta": 34.0,
            "from": 62.0,
            "metric": "hunger",
            "replay": {
              "actions": [
                "problem_set",
                "library_day",
                "german_course",
                "language_tandem"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "exam_week",
              "max_weeks": 18,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 18
            },
            "to": 96.0
          },
          "kind": "single_week_spike",
          "message": "`hunger` jumped from 62.0 to 96 in a single week (Δ=+34.0).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 18
        },
        {
          "evidence": {
            "replay": {
              "actions": [
                "problem_set",
                "library_day",
                "language_tandem",
                "write_email_practice"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "visa_status_hidden_check",
              "max_weeks": 18,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 14
            },
            "streak_weeks": 1,
            "threshold": 85.0
          },
          "kind": "hunger_ignored_too_long",
          "message": "Hunger ≥ 85 for 1 consecutive weeks (week=14).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 14
        }
      ],
      "attractors": [],
      "available_action_ids": [
        "problem_set",
        "library_day",
        "german_course",
        "language_tandem",
        "write_email_practice",
        "watch_german_news",
        "international_office",
        "emergency_international_office",
        "write_formal_email_to_abh",
        "part_time_job",
        "mini_job_extra",
        "scholarship",
        "budget_call",
        "sell_unused_stuff",
        "rent_talk_extension",
        "cook_at_home",
        "cheap_noodle_week",
        "mensa_coupon",
        "wg_dinner",
        "student_club",
        "classmate_meal",
        "date_night",
        "sleep_recover",
        "go_running",
        "take_a_real_break",
        "bilibili_rest",
        "cv_workshop",
        "apply_howi"
      ],
      "decision": {
        "confidence": 1.0,
        "expected_tradeoff": "deterministic fixture authoring choice",
        "risk_awareness": [
          "registration_delayed",
          "stress"
        ],
        "strategic_goal": "exercise money priorities"
      },
      "delta": {
        "academic_progress": 5,
        "energy": 8,
        "hunger": 34,
        "loneliness": 3,
        "money": -105,
        "social": 2
      },
      "event": {
        "id": "exam_week",
        "legal_choices": [
          {
            "choice_id": "exam_week.choice_01_先做会的题",
            "failure_effects": {
              "exam_readiness": -3.0,
              "stress": 8.0
            },
            "next_event_id": "",
            "requirements": {
              "exam_readiness": 0.004,
              "stress": -0.002
            },
            "set_flag": "",
            "success_effects": {
              "exam_readiness": 5.0,
              "stress": 4.0
            },
            "success_rate": 0.444,
            "text": "先做会的题"
          },
          {
            "choice_id": "exam_week.choice_02_硬翻译题目",
            "failure_effects": {
              "exam_readiness": -4.0,
              "stress": 12.0
            },
            "next_event_id": "",
            "requirements": {
              "language": 0.004,
              "stress": -0.002
            },
            "set_flag": "",
            "success_effects": {
              "exam_readiness": 2.0,
              "language": 3.0,
              "stress": 7.0
            },
            "success_rate": 0.604,
            "text": "硬翻译题目"
          },
          {
            "choice_id": "exam_week.choice_03_先扫整张卷子分配时间",
            "failure_effects": {
              "stress": 7.0
            },
            "next_event_id": "",
            "requirements": {
              "exam_readiness": 0.005
            },
            "set_flag": "",
            "success_effects": {
              "exam_readiness": 7.0,
              "stress": 2.0
            },
            "success_rate": 0.404,
            "text": "先扫整张卷子分配时间"
          },
          {
            "choice_id": "exam_week.choice_04_盯着第一题死磕",
            "failure_effects": {
              "exam_readiness": -8.0,
              "stress": 14.0
            },
            "next_event_id": "",
            "requirements": {
              "stress": -0.002
            },
            "set_flag": "",
            "success_effects": {
              "exam_readiness": -5.0,
              "stress": 10.0
            },
            "success_rate": 0.104,
            "text": "盯着第一题死磕"
          }
        ],
        "selected_choice_id": "exam_week.choice_02_硬翻译题目"
      },
      "evidence": {
        "decision_request_fingerprint": "29f4746f227a30e1184f69e3a96aff40e378da1dfb6d8a3f31b3c613b1a8747b",
        "event_request_fingerprint": "082e18a88c9795aceaf36e01a6287c8ef4e40d80a868c9b18792c8a4073be7ad",
        "source_line": 18,
        "source_record_sha256": "bf586b45ac49032e81fa342cae985907a73cc37ada66f19582404746e27677c4"
      },
      "finished": false,
      "full_numeric_delta": {
        "academic_progress": 5,
        "arrears_amount": 170,
        "cash_shortfall_count": 1,
        "energy": 8,
        "hunger": 34,
        "loneliness": 3,
        "money": -105,
        "social": 2,
        "unpaid_social_streak": 2,
        "week": 1
      },
      "id": "w18",
      "kind": "actual",
      "risk_guidance": {
        "contract_version": "1.0",
        "evaluator": "RiskEvaluator.get_top_risks",
        "generated_for_week": 19,
        "source": "game_risk_evaluator",
        "top_risks": [
          {
            "body": "压力 100。高压会拖累学业和考试，并可能覆盖普通成功结局。",
            "id": "stress",
            "score": 100,
            "suggested_actions": [
              "take_a_real_break",
              "therapy",
              "sleep_recover",
              "go_running"
            ],
            "title": "压力"
          },
          {
            "body": "当前可支配现金 0 EUR，逾期 3607 EUR。逾期会推高压力和饥饿，并诱发黑工选择。",
            "id": "money",
            "score": 96,
            "suggested_actions": [
              "rent_talk_extension",
              "budget_call",
              "part_time_job",
              "sell_unused_stuff",
              "cook_at_home"
            ],
            "title": "现金流"
          },
          {
            "body": "饥饿 96。吃饭问题会持续扣精力、加压力、拖学业。",
            "id": "hunger",
            "score": 96,
            "suggested_actions": [
              "cook_at_home",
              "cheap_noodle_week",
              "mensa_coupon",
              "classmate_meal",
              "wg_dinner"
            ],
            "title": "饥饿/生活"
          }
        ]
      },
      "selected_action_ids": [
        "problem_set",
        "library_day",
        "german_course",
        "language_tandem"
      ],
      "state_after": {
        "academic_progress": 98,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 3607,
        "blocked_account_balance": 6944,
        "career_progress": 0,
        "cash_shortfall_count": 15,
        "current_week_work_hours": 0,
        "energy": 24,
        "exam_readiness": 100,
        "failed_courses": 0,
        "flags": {
          "arrears": true,
          "arrived_supplied": true,
          "cash_shortfall": true,
          "cashflow_crisis": true,
          "cashflow_warning": true,
          "housing_contract_active": true,
          "housing_stable": true,
          "illegal_work_taken": true,
          "no_close_friends": true,
          "registration_delayed": true,
          "shallow_friendships": true,
          "testdaf_passed": true,
          "visa_valid": true,
          "work_law_briefed": true
        },
        "gpa_score": 61,
        "hunger": 96,
        "language": 100,
        "loneliness": 71,
        "money": 0,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 53,
        "stress": 100,
        "testdaf_listening": 5,
        "testdaf_reading": 5,
        "testdaf_speaking": 5,
        "testdaf_writing": 5,
        "university_tier": "未定位",
        "unpaid_social_streak": 36,
        "visa_progress": 71,
        "week": 19,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "state_before": {
        "academic_progress": 93,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 3437,
        "blocked_account_balance": 6944,
        "career_progress": 0,
        "cash_shortfall_count": 14,
        "current_week_work_hours": 0,
        "energy": 16,
        "exam_readiness": 100,
        "failed_courses": 0,
        "flags": {
          "arrears": true,
          "arrived_supplied": true,
          "cash_shortfall": true,
          "cashflow_crisis": true,
          "cashflow_warning": true,
          "housing_contract_active": true,
          "housing_stable": true,
          "illegal_work_taken": true,
          "no_close_friends": true,
          "registration_delayed": true,
          "shallow_friendships": true,
          "testdaf_passed": true,
          "visa_valid": true,
          "work_law_briefed": true
        },
        "gpa_score": 61,
        "hunger": 62,
        "language": 100,
        "loneliness": 68,
        "money": 105,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 51,
        "stress": 100,
        "testdaf_listening": 5,
        "testdaf_reading": 5,
        "testdaf_speaking": 5,
        "testdaf_writing": 5,
        "university_tier": "未定位",
        "unpaid_social_streak": 34,
        "visa_progress": 71,
        "week": 18,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "week": 18
    },
    {
      "anomalies": [
        {
          "evidence": {
            "delta": 33.0,
            "from": 49.0,
            "metric": "stress",
            "replay": {
              "actions": [
                "problem_set",
                "library_day",
                "language_tandem",
                "write_email_practice"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "missing_school_registration",
              "max_weeks": 19,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 3
            },
            "to": 82.0
          },
          "kind": "single_week_spike",
          "message": "`stress` jumped from 49.0 to 82 in a single week (Δ=+33.0).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 3
        },
        {
          "evidence": {
            "delta": 34.0,
            "from": 39.0,
            "metric": "hunger",
            "replay": {
              "actions": [
                "problem_set",
                "library_day",
                "language_tandem",
                "write_email_practice"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "missing_school_registration",
              "max_weeks": 19,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 3
            },
            "to": 73.0
          },
          "kind": "single_week_spike",
          "message": "`hunger` jumped from 39.0 to 73 in a single week (Δ=+34.0).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 3
        },
        {
          "evidence": {
            "delta": -38.0,
            "from": 100.0,
            "metric": "hunger",
            "replay": {
              "actions": [
                "problem_set",
                "library_day",
                "language_tandem",
                "write_email_practice"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "classmate_home_dinner",
              "max_weeks": 19,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 17
            },
            "to": 62.0
          },
          "kind": "single_week_spike",
          "message": "`hunger` jumped from 100.0 to 62 in a single week (Δ=-38.0).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 17
        },
        {
          "evidence": {
            "delta": 34.0,
            "from": 62.0,
            "metric": "hunger",
            "replay": {
              "actions": [
                "problem_set",
                "library_day",
                "german_course",
                "language_tandem"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "exam_week",
              "max_weeks": 19,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 18
            },
            "to": 96.0
          },
          "kind": "single_week_spike",
          "message": "`hunger` jumped from 62.0 to 96 in a single week (Δ=+34.0).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 18
        },
        {
          "evidence": {
            "replay": {
              "actions": [
                "problem_set",
                "library_day",
                "language_tandem",
                "write_email_practice"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "visa_status_hidden_check",
              "max_weeks": 19,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 14
            },
            "streak_weeks": 2,
            "threshold": 85.0
          },
          "kind": "hunger_ignored_too_long",
          "message": "Hunger ≥ 85 for 2 consecutive weeks (week=14).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 14
        }
      ],
      "attractors": [],
      "available_action_ids": [
        "problem_set",
        "library_day",
        "language_tandem",
        "write_email_practice",
        "watch_german_news",
        "international_office",
        "emergency_international_office",
        "write_formal_email_to_abh",
        "part_time_job",
        "mini_job_extra",
        "scholarship",
        "budget_call",
        "sell_unused_stuff",
        "rent_talk_extension",
        "sleep_recover",
        "go_running",
        "take_a_real_break",
        "bilibili_rest",
        "cv_workshop",
        "apply_howi"
      ],
      "decision": {
        "confidence": 1.0,
        "expected_tradeoff": "deterministic fixture authoring choice",
        "risk_awareness": [
          "registration_delayed",
          "hunger",
          "stress"
        ],
        "strategic_goal": "exercise money priorities"
      },
      "delta": {
        "academic_progress": -4,
        "energy": -8,
        "hunger": 4,
        "loneliness": 3,
        "social": 1,
        "stress": -4,
        "visa_progress": 2
      },
      "event": {
        "id": "after_exam_void",
        "legal_choices": [
          {
            "choice_id": "after_exam_void.choice_01_休息半天",
            "failure_effects": {
              "energy": -4.0,
              "stress": 4.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "energy": 12.0,
              "stress": -10.0
            },
            "success_rate": 1.0,
            "text": "休息半天"
          },
          {
            "choice_id": "after_exam_void.choice_02_立刻复盘",
            "failure_effects": {
              "academic_progress": -1.0,
              "stress": 2.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "academic_progress": 3.0,
              "stress": 3.0
            },
            "success_rate": 1.0,
            "text": "立刻复盘"
          },
          {
            "choice_id": "after_exam_void.choice_03_稳妥处理",
            "failure_effects": {
              "academic_progress": 1.0,
              "stress": 4.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "academic_progress": 3.0,
              "stress": 1.0
            },
            "success_rate": 0.582,
            "text": "稳妥处理"
          },
          {
            "choice_id": "after_exam_void.choice_04_寻求帮助",
            "failure_effects": {
              "social": -1.0,
              "stress": 3.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "academic_progress": 2.0,
              "social": 2.0,
              "stress": -2.0
            },
            "success_rate": 0.82,
            "text": "寻求帮助"
          }
        ],
        "selected_choice_id": "after_exam_void.choice_03_稳妥处理"
      },
      "evidence": {
        "decision_request_fingerprint": "48868be038cebf92b26eae35607851d7b4b32ac9a4eaf79767579288c90c4a75",
        "event_request_fingerprint": "da0716912fa1c0d3ce1fd85a6a267c3d2abf82ea0d40a537682f2fada6d61656",
        "source_line": 19,
        "source_record_sha256": "e0458a9d636e442c8343fb6958352cb82e02617c87eb8768ee92fdd338409814"
      },
      "finished": true,
      "full_numeric_delta": {
        "academic_progress": -4,
        "arrears_amount": 255,
        "cash_shortfall_count": 1,
        "energy": -8,
        "hunger": 4,
        "loneliness": 3,
        "social": 1,
        "stress": -4,
        "unpaid_social_streak": 2,
        "visa_progress": 2,
        "week": 1
      },
      "id": "w19",
      "kind": "actual",
      "risk_guidance": {
        "contract_version": "1.0",
        "evaluator": "RiskEvaluator.get_top_risks",
        "generated_for_week": 20,
        "source": "game_risk_evaluator",
        "top_risks": [
          {
            "body": "饥饿 100。吃饭问题会持续扣精力、加压力、拖学业。",
            "id": "hunger",
            "score": 100,
            "suggested_actions": [
              "cook_at_home",
              "cheap_noodle_week",
              "mensa_coupon",
              "classmate_meal",
              "wg_dinner"
            ],
            "title": "饥饿/生活"
          },
          {
            "body": "当前可支配现金 0 EUR，逾期 3862 EUR。逾期会推高压力和饥饿，并诱发黑工选择。",
            "id": "money",
            "score": 96,
            "suggested_actions": [
              "rent_talk_extension",
              "budget_call",
              "part_time_job",
              "sell_unused_stuff",
              "cook_at_home"
            ],
            "title": "现金流"
          },
          {
            "body": "压力 96。高压会拖累学业和考试，并可能覆盖普通成功结局。",
            "id": "stress",
            "score": 96,
            "suggested_actions": [
              "take_a_real_break",
              "therapy",
              "sleep_recover",
              "go_running"
            ],
            "title": "压力"
          }
        ]
      },
      "selected_action_ids": [
        "problem_set",
        "library_day",
        "language_tandem",
        "write_email_practice"
      ],
      "state_after": {
        "academic_progress": 94,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 3862,
        "blocked_account_balance": 6944,
        "career_progress": 0,
        "cash_shortfall_count": 16,
        "current_week_work_hours": 0,
        "energy": 16,
        "exam_readiness": 100,
        "failed_courses": 0,
        "flags": {
          "arrears": true,
          "arrived_supplied": true,
          "cash_shortfall": true,
          "cashflow_crisis": true,
          "cashflow_warning": true,
          "housing_contract_active": true,
          "housing_stable": true,
          "illegal_work_taken": true,
          "no_close_friends": true,
          "registration_delayed": true,
          "shallow_friendships": true,
          "testdaf_passed": true,
          "visa_valid": true,
          "work_law_briefed": true
        },
        "gpa_score": 61,
        "hunger": 100,
        "language": 100,
        "loneliness": 74,
        "money": 0,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 54,
        "stress": 96,
        "testdaf_listening": 5,
        "testdaf_reading": 5,
        "testdaf_speaking": 5,
        "testdaf_writing": 5,
        "university_tier": "未定位",
        "unpaid_social_streak": 38,
        "visa_progress": 73,
        "week": 20,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "state_before": {
        "academic_progress": 98,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 3607,
        "blocked_account_balance": 6944,
        "career_progress": 0,
        "cash_shortfall_count": 15,
        "current_week_work_hours": 0,
        "energy": 24,
        "exam_readiness": 100,
        "failed_courses": 0,
        "flags": {
          "arrears": true,
          "arrived_supplied": true,
          "cash_shortfall": true,
          "cashflow_crisis": true,
          "cashflow_warning": true,
          "housing_contract_active": true,
          "housing_stable": true,
          "illegal_work_taken": true,
          "no_close_friends": true,
          "registration_delayed": true,
          "shallow_friendships": true,
          "testdaf_passed": true,
          "visa_valid": true,
          "work_law_briefed": true
        },
        "gpa_score": 61,
        "hunger": 96,
        "language": 100,
        "loneliness": 71,
        "money": 0,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 53,
        "stress": 100,
        "testdaf_listening": 5,
        "testdaf_reading": 5,
        "testdaf_speaking": 5,
        "testdaf_writing": 5,
        "university_tier": "未定位",
        "unpaid_social_streak": 36,
        "visa_progress": 71,
        "week": 19,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "week": 19
    }
  ],
  "persona": "money",
  "provider": "replay",
  "provider_mode": "replay",
  "provider_revision": "fixture:865f4fb83028f7ada18b581462adef3cbb15f2b06ed4c59cb0601f97b0d5f590",
  "scenario": "default_first_semester",
  "schema_version": "playthrough-view-v1",
  "seed": 42,
  "source_trace": {
    "artifact_path": "reports/playthrough-evidence/campaigns/playthrough-evidence-full-v1/cells/money-seed-42-0814df41bd32/playthrough.jsonl",
    "artifact_sha256": "af5935af439f04e7251fc1bbd29692c9910b30d7711e7601c842857ab8459425",
    "record_count": 19
  },
  "stop_reason": "game_finished",
  "truth_label": "prerecorded-real-godot-replay"
}
